// src/data/districtData.js
import img3 from "../../../assets/images/Home/palgharimg3.jpg";
import korigad1 from "../../../assets/images/Monuments Images/Pune/1.Koirigarh Fort/DSC_0775.JPG";
import kukdeswar from "../../../assets/images/Monuments Images/Pune/2. Kukdeswar Temple/_DSC0778.JPG";
import khandoba from "../../../assets/images/Monuments Images/Pune/3.Khandoba Temple/394d35b5-6bbe-47a7-bef2-c5d332bff077.jpg";
import torna from "../../../assets/images/Monuments Images/Pune/4.Torna Fort/DSC_0144.JPG";
import tanajimalusare from "../../../assets/images/Monuments Images/Pune/5.Tanaji Malusare Samadhi/_DSC0385.JPG";
import copper from "../../../assets/images/Monuments Images/Pune/6.Copper age settlement/01.jpg";
import nagehswar from "../../../assets/images/Monuments Images/Pune/7.Nageshwar Temple/DSC_0078.JPG";
import mastani11 from "../../../assets/images/Monuments Images/Pune/9.Mastani tomb/7.jpg";
import mahadev from "../../../assets/images/Monuments Images/Pune/10.Mahadev Temple/Mahadev_Temple_Tulapur_East_Elevation_4.jpg";
import mahatmaphule from "../../../assets/images/Monuments Images/Pune/11.Mahatma Phule Wada/04.jpg";
import mahadevandtula from "../../../assets/images/Monuments Images/Pune/12.Mahadev Temple and Datta Temple Complex/DSC_0129.JPG";
import raigad from "../../../assets/images/Monuments Images/Pune/13.Rajgad Fort/DroneView (40).jpg";
import vishrambaug from "../../../assets/images/Monuments Images/Pune/15.Vishrambaug Wada/DSC00015.JPG";
import sangramdurg from "../../../assets/images/Monuments Images/Pune/16.Sangramdurg Fort/DJI_0484.JPG";
import cripsins from "../../../assets/images/Monuments Images/Pune/17.St. Cripsin's Church/DSC_0210.JPG";
import santaji from "../../../assets/images/Monuments Images/Pune/18.Santaji Jagannath Maharaj's tomb/01_page-0001.jpg";
import sambhaji from "../../../assets/images/Monuments Images/Pune/19.Sambhaji Maharaj's tomb/14.jpg";
import sinhagad from "../../../assets/images/Monuments Images/Pune/20.Sinhagad Fort/01.jpg";
import martyr from "../../../assets/images/Monuments Images/Pune/21.Martyr Rajguru Wada/Hutatma_Rajguru_wada_Thorla_Wada_Est_Elevation.png";
import narasimha from "../../../assets/images/Monuments Images/Pune/22.Narasimha Temple/niranarsinhpur1.JPG";
import sardarkanoji from "../../../assets/images/Monuments Images/Pune/23.Sardar Kanhoji Jedhe Wada/DSC00018 copy.jpg";
import pandavdara from "../../../assets/images/Monuments Images/Pune/24.Pandavdara Caves, Panhala, Kolhapur/DSC00152.JPG";
import drbabasaheb from "../../../assets/images/Monuments Images/Satara/1.Dr. Babasaheb Ambedkar Residence/Screenshot 2025-07-29 170053.png";
import vasudeva from "../../../assets/images/Monuments Images/Satara/2.Vasudeva Swamy Math/DSC01265.JPG";
import bhairavanath from "../../../assets/images/Monuments Images/Satara/3.Bhairavanath Temple/IMG_1088.JPG";
import savitribai from "../../../assets/images/Monuments Images/Satara/4.Birthplace of Savitribai Phule/1_page-0001 (1).jpg";
import senapatihambirrao from "../../../assets/images/Monuments Images/Satara/5.Tomb of Sir Senapati Hambirrao Mohite/01.jpg";
import maharaniyesubai from "../../../assets/images/Monuments Images/Satara/6.Maharani Yesubai's Tomb (Satara)/2.jpeg";
import pratapgad from "../../../assets/images/Monuments Images/Satara/7.Pratapgad Fort. Mahabaleshwar, Satara/01.jpg";
import mahadevtemplesolapur from "../../../assets/images/Monuments Images/Solapur/1.Mahadev Temple/Mahadev_Temple_Kasegaon_East_Elevation.JPG";
import sangameshwar from "../../../assets/images/Monuments Images/Solapur/2.Sangameshwar and Muralidhar Temple/02.jpg";
import madhafort from "../../../assets/images/Monuments Images/Solapur/3.Madha Fort/DSC01167.JPG";
import mangalveda from "../../../assets/images/Monuments Images/Solapur/4.Mangalveda Fort, Mangalveda, Solapur/DSC_0088.JPG";
import kalmadevi from "../../../assets/images/Monuments Images/Sangli/1.Kalmadevi Temple/223.jpg"
import yashwantrao from "../../../assets/images/Monuments Images/Sangli/2.Yashwantrao Chavan Birthplace/29. Yashwantrao Chavhan Birthplace_page-0001.jpg"
import pandavapas from "../../../assets/images/Monuments Images/Kolhapur/1.Pandava Pass Shaiva Caves/Baudha Caves in Maharashtra.JPG"
import bajiprabhu from "../../../assets/images/Monuments Images/Kolhapur/2.Bajiprabhu and Phulajiprabhu Deshpande's tomb/Bajiprabhu_&_Phulajiprabhu_Deshpande_Samadhi_Cinematic_Photo_1.JPG"
import bhudargad from "../../../assets/images/Monuments Images/Kolhapur/3.Bhudargad Fort/DSC_0248.JPG"
import kolhapurmahadev from "../../../assets/images/Monuments Images/Kolhapur/4.Mahadev Temple, Aarey/100_3991.JPG"
import lakshmivilas from "../../../assets/images/Monuments Images/Kolhapur/5.Lakshmi Vilas Palace/laxmi vilas palce kolhapur (1).JPG"
import crawling from "../../../assets/images/Monuments Images/Kolhapur/6.Crawling fort/Rangana Fort.jpg"
import ramachandra from "../../../assets/images/Monuments Images/Kolhapur/7.Ramachandra Pant Amatya Samadhi/DSC00314.JPG"
import vishalgad from "../../../assets/images/Monuments Images/Kolhapur/8.Vishalgad/vishalgad_fort3.jpg"
import jambuwanttemple from "../../../assets/images/Monuments Images/District Jalna/1.Jambuwant Temple/2017-12-05.jpg"
import Bhokardan from "../../../assets/images/Monuments Images/District Jalna/2. Bhokardan  caves/DSC_0282.jpg"
import mahadevtempleanwa from "../../../assets/images/Monuments Images/District Jalna/3. Mahadev Temple Anwa/DSC_0131.jpg"
import amargad from "../../../assets/images/Monuments Images/District Jalna/4. Amargad Fort/IMG_20170601_130026.jpg"
import prehistoric from "../../../assets/images/Monuments Images/District Jalna/5.Historical place - (Kisan Mhaske)/WhatsApp Image 2024-03-25 at 7.15.31 PM.jpeg"
import abulhasan from "../../../assets/images/Monuments Images/sambhajinagar/001 Abulhasan Tana Shahache Tomb/1.JPG"
import aasafjahan from "../../../assets/images/Monuments Images/sambhajinagar/002. Aasafjahan I che Tomb/1.JPG"
import delhidarwaja from "../../../assets/images/Monuments Images/sambhajinagar/003. Delhi Darwaja/1.JPG"
import narsihnha from "../../../assets/images/Monuments Images/sambhajinagar/004. Narsihnha Sculpture/1.jpg"
import makaidarwaja from "../../../assets/images/Monuments Images/sambhajinagar/005. Makai Darwaja/1.jpg"
import lalahardaaul from "../../../assets/images/Monuments Images/sambhajinagar/006. Lala Hardaaul Samadhi/1.JPG"
import sheshshahi from "../../../assets/images/Monuments Images/sambhajinagar/007. Sheshshahi Vishnu Sculpture/1.JPG"
import kalimasjid from "../../../assets/images/Monuments Images/sambhajinagar/008. Kali Masjid/1.JPG"
import khandobatemplesambhajinagar from "../../../assets/images/Monuments Images/sambhajinagar/009. Khandoba Temple/1.JPG"
import khanjahan from "../../../assets/images/Monuments Images/sambhajinagar/010. Khan-a-jahan Bag/1.JPG"
import shahagujMasjid1 from "../../../assets/images/Monuments Images/sambhajinagar/031. Shahaguj Masjid/DSC_0321.JPG";
import royalhammam1 from "../../../assets/images/Monuments Images/sambhajinagar/032. Shahi Hamam/DSC_0001_041.JPG";
import goldenpalace1 from "../../../assets/images/Monuments Images/sambhajinagar/033. Soneri Mahal/IMG_9939.JPG";
import salarjungbaradari1 from "../../../assets/images/Monuments Images/sambhajinagar/034. Baradari/IMG_3726.JPG";
import banibegumbagh1 from "../../../assets/images/Monuments Images/sambhajinagar/036.Bani Begam Bag/DSC_1706.JPG";
import ajantasarai1 from "../../../assets/images/Monuments Images/sambhajinagar/035. Ajintha Sarai/IMG_3656.JPG";
import anturfort1 from "../../../assets/images/Monuments Images/sambhajinagar/038. Antur Fort/DSC02715.JPG";
import tombofazamshah1 from "../../../assets/images/Monuments Images/sambhajinagar/039. Tomb of Azam Shah/DSC_1625.JPG";
import fardapursarai1 from "../../../assets/images/Monuments Images/sambhajinagar/041. Fardapur Sarai/IMG_3363.JPG";
import ghatotkach1 from "../../../assets/images/Monuments Images/sambhajinagar/011. Ghatotkach Caves/1.jpg"
import chowk1 from "../../../assets/images/Monuments Images/sambhajinagar/012. Chouk Masjid/1.jpg"
import jogeshwari1 from "../../../assets/images/Monuments Images/sambhajinagar/013. Jogeshwari devi Cave Temple/jogeshwari1.jpg"
import jamemasjid1 from "../../../assets/images/Monuments Images/sambhajinagar/014.Jama Masjid/jame-masjid1.jpg"
import pilgrimage1 from "../../../assets/images/Monuments Images/sambhajinagar/015. Tirth Stambh/1.jpg"
import taltam1 from "../../../assets/images/Monuments Images/sambhajinagar/016. Taltam Fort/taltam1.jpg"
import nageshwar1 from "../../../assets/images/Monuments Images/sambhajinagar/017. Nageshwar Temple Rahimabad/nageshwar.jpg"
import navkhanda1 from "../../../assets/images/Monuments Images/sambhajinagar/018. Navkhanda Palace/1.jpg"
import nasir1 from "../../../assets/images/Monuments Images/sambhajinagar/019. Nasirjang Shahid Tomb/1.jpg"
import prehistoric1 from "../../../assets/images/Monuments Images/sambhajinagar/020. Prachin Wastu Awashesh Milanare Sthal/1.jpg"
import panchakki from "../../../assets/images/Monuments Images/sambhajinagar/021. Panchakki/DSC01424.JPG"
import archlogiessite from "../../../assets/images/Monuments Images/sambhajinagar/020. Prachin Wastu Awashesh Milanare Sthal/2.jpg"
import vetalvadi from "../../../assets/images/Monuments Images/sambhajinagar/023. Vaitalwadi Fort/DSC06894.JPG"
import bhadkaldoor from "../../../assets/images/Monuments Images/sambhajinagar/024. Bhadkal Darwaja/DSC_0305.jpg"
import munim from "../../../assets/images/Monuments Images/sambhajinagar/025. Munim Bag/DSC00891.JPG"
import malojirajefort from "../../../assets/images/Monuments Images/sambhajinagar/026. Maloji Raje Bhosale Gadhi Remains/DSC02226.JPG"
import rudreshwarecaves from "../../../assets/images/Monuments Images/sambhajinagar/027. Rudreshwar Caves/Dsc00742.jpg"
import lalmasjid from "../../../assets/images/Monuments Images/sambhajinagar/028. Lal Masjid/DSC00700.JPG"
import vadeshwartemple from "../../../assets/images/Monuments Images/sambhajinagar/029. Wadeshwar Mahadev Temple/DSC06754.JPG"
import incriptedpillar from "../../../assets/images/Monuments Images/sambhajinagar/030. Incripted Pillar/DSC00516..jpg"

import kholeshwartemple from "../../../assets/images/Monuments Images/Beed/6.Kholeshwar Temple/DSC01937.JPG"
import khandeshwaritemple from "../../../assets/images/Monuments Images/Beed/7. Khandeshwari Temple/DSC_0024.JPG"
import rustydoor from "../../../assets/images/Monuments Images/Beed/8. Gunj Gate/Picture2.jpg"
import jogaihall from "../../../assets/images/Monuments Images/Beed/9.Jogai Assembly Hall/DSC01864.JPG"
import amaleshwar1 from "../../../assets/images/Monuments Images/Beed/1.Amaleshwar Temple/amaleshwar1.jpg"
import mukundraj1 from "../../../assets/images/Monuments Images/Beed/2.The first poet Shri Mukundaraj/mukundraj1.jpg"
import kankaleshwar1 from "../../../assets/images/Monuments Images/Beed/3.Kankaleshwar Temple/kankaleshwar1.jpg"
import kedareshwar1 from "../../../assets/images/Monuments Images/Beed/4.Kedareshwar Temple/kedareshwar1.jpg"
import angled1 from "../../../assets/images/Monuments Images/Beed/5.Angled door/angled1.jpg"
import dharurfort1 from "../../../assets/images/Monuments Images/Beed/11. Dharur Fort/DSC_1618.JPG";
import dharmapurifort1 from "../../../assets/images/Monuments Images/Beed/12. Dharmapuri Fort/IMG_1063.JPG";
import stonedoor1 from "../../../assets/images/Monuments Images/Beed/13. Stone door/DJI_20250302120625_0325_D.JPG";
import pirbalshahdargah1 from "../../../assets/images/Monuments Images/Beed/14.Paribala Shaha Dargah/DJI_20250301161151_0964_D.JPG";
import mahadevtemplepatoda1 from "../../../assets/images/Monuments Images/Beed/15. Patoda Mahadev Temple/DSC_0637.JPG";
import tombToothMuhammadbinTughlaq1 from "../../../assets/images/Monuments Images/Beed/16.Tomb of the Tooth of Muhammad-bin-Tughlaq/04 (1).jpg";
import rajurimosque from "../../../assets/images/Monuments Images/Beed/21. Rajuri Mosque ( Content not Recived)/DJI_20250302094407_0153_D.JPG"
import Shanshahawali from "../../../assets/images/Monuments Images/Beed/20. Shanshahawali Dargah/DSC07066.JPG"
import tombannapurna from "../../../assets/images/Monuments Images/Beed/19.Tomb of Queen Annapurna Bai/01.jpg"
import battlepillar from "../../../assets/images/Monuments Images/Beed/18. Rankhamb/DJI_20250301164646_0984_D.JPG"
import rajurigate from "../../../assets/images/Monuments Images/Beed/17. Rajuri Gate/DSC_0135.JPG"
import mahalakshmitemple from "../../../assets/images/Monuments Images/Dharashiv/22. Mahalaxi Temple Jagji/DSC05595 - Edited2.jpg"
import shivgurutemple from "../../../assets/images/Monuments Images/Dharashiv/24. Shivguru Samadhi Temple/2QDhJfLBaStYY6QKM3y5ChKX.jpg"
import gorobakahouse from "../../../assets/images/Monuments Images/Dharashiv/25. Goroba Kaka Ghar/DSC_0733.JPG"
import hazaratdargah from "../../../assets/images/Monuments Images/Dharashiv/26. Hazarat Shamshuddin Dargah/KWAJABANDENAWAZ_DARGAH.jpg"
import hindumandir from "../../../assets/images/Monuments Images/Dharashiv/27.Hindu mandir/hindu mandir1.png"

import dharashiv1 from "../../../assets/images/Monuments Images/Dharashiv/15 Dharashiv Caves/dharashiv1.jpg"
import naldurg1 from "../../../assets/images/Monuments Images/Dharashiv/16. Naldurg Fort/1.jpg"
import paranda1 from "../../../assets/images/Monuments Images/Dharashiv/18. Paranda Fort/1.jpg"
import tulja1 from "../../../assets/images/Monuments Images/Dharashiv/19. Tulja Bhavani/1.jpg"
import mahadev11 from "../../../assets/images/Monuments Images/Dharashiv/20. Mahadev Temple, Umarga/1.jpg"
import mahadev111 from "../../../assets/images/Monuments Images/Dharashiv/21. Mahadev Temple, Mankeshwar/1.jpg"
import uttareshwar1 from "../../../assets/images/Monuments Images/Dharashiv/1. Uttareshwar Temple/DSC07194.JPG"
import chambharcaves1 from "../../../assets/images/Monuments Images/Dharashiv/2. Chambhar Caves/DSC04220.JPG"
import trivikramtemple1 from "../../../assets/images/Monuments Images/Dharashiv/3.Trivikram Temple/DJI_20250312164457_0098_D (1).JPG"
import historicalplacekisanmhaske1 from "../../../assets/images/Monuments Images/Dharashiv/4. Stupa (Kisan Mhaske Farm)/WhatsApp Image 2024-03-25 at 7.15.31 PM.jpeg"
import shrine1 from "../../../assets/images/Monuments Images/Dharashiv/5. Tirthkund (Shrine)/DJI_0605.JPG"
import jaincaves1 from "../../../assets/images/Monuments Images/nandurbar district/DSC_0325.JPG"
import bhavanitempleandvishnutemple1 from "../../../assets/images/Monuments Images/District Dhule (4 +1)/Bhavani Temple and Vishnu Temple (Balaji Temple)/DSC_0607.JPG"
import harbatemplemahadev1 from "../../../assets/images/Monuments Images/District Dhule (4 +1)/Harba TempleMahadev Temple/Methi.jpg"
import kalikadevitemple1 from "../../../assets/images/Monuments Images/District Dhule (4 +1)/Kalikadevi Temple/DSC_0963.JPG"
import lalingfort1 from "../../../assets/images/Monuments Images/District Dhule (4 +1)/Laling Fort/001 copy.jpg"
import ankaifort1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/1.Ankai Fort/DSC_0057.JPG"
import hatgadfort1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/2.Hatgad Fort/DSC08048.JPG"
import swatantryaveersavarkar1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/3.Swatantryaveer Savarkar's birthplace and well/29.jpg"
import SalherFort1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/4.Salher Fort/DSC_0406.JPG"
import governmenthouse from "../../../assets/images/Monuments Images/Nashik District (28+1)/5.Government House/26.jpg"
import SundernarayanTemple1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/6.Sundernarayan Temple/DSC02874.JPG"
import vateswarmahadevtemple1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/7.Vateswar Mahadev Temple/DSC_0244.JPG"
import vaijeshwartemple1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/8.Vaijeshwar Temple/DSC03742.JPG"
import vishnutemple1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/9.Vishnu Temple/DSC_0233.JPG"
import renukadevitemple1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/10.Renukadevi Temple/01.jpg"
import raghaveshwarmahadevtemple1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/11.Raghaveshwar Mahadev Temple/DSC_0574.JPG"
import rangmahal1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/12.Rangmahal/9.jpg"
import mulherfort1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/13.Mulher Fort/DSC_0521.JPG"
import malegaonfort1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/14.Malegaon Fort/DSC05757.JPG"
import mukteshwarmahadevtemple1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/15.Mukteshwar Mahadev Temple/DSC_0084.JPG"
import ballaleshwartemple1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/16.Ballaleshwar Temple/DSC_0917.JPG"
import parswanathjaincaves1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/17.Parswanath Jain Caves/Trimbakeshwar 1.JPG"
import neelkantheshwarmahadevtemple1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/18.Neelkantheshwar Mahadev Temple/001.JPG"
import tatobatemple1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/19.Tatoba Temple/DSC04053.JPG"
import tribhuvaneshwar1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/20.Tribhuvaneshwar/Tribhuvaneshwar 1.jpg"
import jaincaveskalikatemple1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/21.Jain Caves (Kalika Temple)/DSC_0163.JPG"
import galanafort1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/22.Galana Fort/06.jpg"
import indraleshwartemple1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/23.Indraleshwar Temple/DSC_0863.JPG"
import kushawarthpilgrimage1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/24.Kushawarth pilgrimage/DSC_0111.JPG"
import aranathjaincaves1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/25.Aranath Jain Caves/Trimbakeshwar 2.JPG"
import tankaifort1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/26.Tankai Fort/Tankai Fort (1).JPG"
import devlanamahadevmandir1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/27.Mahadev Temple (Devlana. Tal- Satana. Dist- Nashik)/Devlana Mahadev Mandir.JPG"
import mahadevtempledevalikarad1 from "../../../assets/images/Monuments Images/Nashik District (28+1)/28.Mahadev Temple (Devali Karad. Tal- Kalvan. Dist- Nashik)/01.jpg"
import shivatemple1 from "../../../assets/images/Monuments Images/District Jalgaon (6)/1.Shiva Temple/IMG20181220160347.jpg"
import Ves1 from "../../../assets/images/Monuments Images/District Jalgaon (6)/2.Ves (gate and tower of Amalner Fort)/DSC_0040.JPG"
import parolafort1 from "../../../assets/images/Monuments Images/District Jalgaon (6)/3.Parola Fort/DSC_0559.JPG"
import pandavawadamosque1 from "../../../assets/images/Monuments Images/District Jalgaon (6)/4.Pandava Wada Mosque/Pandavwada Masjid, Arendol 5.JPG"
import kapileshwartemple1 from "../../../assets/images/Monuments Images/District Jalgaon (6)/5.Kapileshwar Temple/DSC_0233.JPG"
import hangingtowers1 from "../../../assets/images/Monuments Images/District Jalgaon (6)/6.Hanging towers/DSC07181.JPG"
import nimbalkargadhi1 from "../../../assets/images/Monuments Images/District Ahmadnagar/1.Nimbalkar Gadhi, Kharda/DSC_0359.JPG"
import harinarayanamath1 from "../../../assets/images/Monuments Images/District Ahmadnagar/2.Harinarayana Math/DSC_0615.JPG"
import birthplaceofsenapatibapat1 from "../../../assets/images/Monuments Images/District Ahmadnagar/3.Birth place of Senapati Bapat/DSC_0609.JPG"
import siddheshwarmahadevtemple1 from "../../../assets/images/Monuments Images/District Ahmadnagar/4.Siddheshwar Mahadev Temple/04.JPG"
import raghaveshwarmahadevtemple11 from "../../../assets/images/Monuments Images/District Ahmadnagar/5.Raghaveshwar Mahadev Temple/01.jpg"
import lakshmitemple1 from "../../../assets/images/Monuments Images/District Ahmadnagar/6.Lakshmi Temple/DSC_0342.JPG"
import raghobadadawada1 from "../../../assets/images/Monuments Images/District Ahmadnagar/7.Raghobadada Wada/DSC_0387.JPG"
import khardafort1 from "../../../assets/images/Monuments Images/District Ahmadnagar/8.Kharda Fort/DJI_0949.JPG"
import mahadevtemple from "../../../assets/images/Monuments Images/District Ahmadnagar/9.Garhi - Birthplace of Ahilyabai Holkar (and Sangha) a) Mahadev Temple b) Chondeshwari Temple c) Ahilyabai Temple/DSC_0789.JPG"
import chondeshwaritemple from "../../../assets/images/Monuments Images/District Ahmadnagar/9.Garhi - Birthplace of Ahilyabai Holkar (and Sangha) a) Mahadev Temple b) Chondeshwari Temple c) Ahilyabai Temple/DSC_0808.JPG"
import ahilyabaitemple from "../../../assets/images/Monuments Images/District Ahmadnagar/9.Garhi - Birthplace of Ahilyabai Holkar (and Sangha) a) Mahadev Temple b) Chondeshwari Temple c) Ahilyabai Temple/DSC_0863.JPG"
import ghummja1 from "../../../assets/images/Monuments Images/Dharashiv/Ghummja/ghummaja.png"

// Buldhana Images 
import Savakarwada from "../../../assets/images/Monuments Images/Nagpur division/District Buldhana/Moneylender/b6.jpg"
import lakhuji from "../../../assets/images/Monuments Images/Nagpur division/District Buldhana/Lakhuji Jadhav Wada/b05.jpg"
import moti from "../../../assets/images/Monuments Images/Nagpur division/District Buldhana/Pearl Lake/b4.jpg"
import nilkantheshwar from "../../../assets/images/Monuments Images/Nagpur division/District Buldhana/Nilkantheshwar Temple and Barav/b1.jpg"

// Akola Images 
import badiroja from "../../../assets/images/Monuments Images/Nagpur division/District Akola/Badi Roja Masjid/A2.jpg"
import darush from "../../../assets/images/Monuments Images/Nagpur division/District Akola/Darush Shararra of Kanchani/A2.jpg"
import inayat from "../../../assets/images/Monuments Images/Nagpur division/District Akola/Inayat Manzil/A1.jpg"

//Washim images
import Delhigate from "../../../assets/images/Monuments Images/Nagpur division/District Washim/Delhi Gate (Wes)/w1.jpg"
import Mangruldoor from "../../../assets/images/Monuments Images/Nagpur division/District Washim/Mangrul Door (Wes)/w3.jpg"
import Pohadoor from "../../../assets/images/Monuments Images/Nagpur division/District Washim/Poha Door (Wes)/w2.jpg"


// Amravati Images 
import stepwell from "../../../assets/images/Monuments Images/Nagpur division/District Amravati/Stepwell/Am1.jpg"
import mother from "../../../assets/images/Monuments Images/Nagpur division/District Amravati/Mother-in-law's well/Am4.jpg"

// Bhandara Images 
import ambagad from "../../../assets/images/Monuments Images/Nagpur division/District Bhandara/Ambagad Fort/b1.jpg"
import gosavi from "../../../assets/images/Monuments Images/Nagpur division/District Bhandara/Gosavi Samadhi/b2.jpg"


import bhogramtemple from "../../../assets/images/Monuments Images/Nagpur division/District Nagpur/Bhogram temple/01.jpg"
import kevalnarasimbha from "../../../assets/images/Monuments Images/Nagpur division/District Nagpur/Keval Narasimha Temple/01.jpg"
import nagardhantemple from "../../../assets/images/Monuments Images/Nagpur division/District Nagpur/Nagardhan Fort/01 (1).jpg"
import ranisahebsamadhi from "../../../assets/images/Monuments Images/Nagpur division/District Nagpur/Queen Saheb's Bakhar/01.jpg"
import rudranrisimbhatemple from "../../../assets/images/Monuments Images/Nagpur division/District Nagpur/Rudra Nrisimha Temple/01 (1).jpg"
import saraswatitemple from "../../../assets/images/Monuments Images/Nagpur division/District Nagpur/Saraswati Temple and Pond/01.jpg"
import shivatemplenagpur from "../../../assets/images/Monuments Images/Nagpur division/District Nagpur/Shiva Temple/01 (1).jpg"
import umredfortnagpur from "../../../assets/images/Monuments Images/Nagpur division/District Nagpur/Umred Fort/01.png"
import varahatemple from "../../../assets/images/Monuments Images/Nagpur division/District Nagpur/Varaha Temple Pavilion/01.jpg"
import birthplaceofsaintnamdev from "../../../assets/images/Monuments Images/Nanded division/District Hingoli/Birthplace of Saint Namdev/h13.jpg"
import hindutemple from "../../../assets/images/Monuments Images/Nanded division/District Hingoli/Hindu temple/h11.jpg"
import khanealamdargah from "../../../assets/images/Monuments Images/Nanded division/District Hingoli/Khan-e-Alam Dargah/h2.jpg"
import nagnathtempleaundha from "../../../assets/images/Monuments Images/Nanded division/District Hingoli/Nagnath Temple, Aundha/h05.jpg"
import ausafort from "../../../assets/images/Monuments Images/Nanded division/District Latur/Ausa Fort/L1.jpg"
import baghehissam from "../../../assets/images/Monuments Images/Nanded division/District Latur/Bagh-e-Hissam/l5.jpg"
import udgirfort from "../../../assets/images/Monuments Images/Nanded division/District Latur/Udgir Fort/l2.jpg"
import goddesstemple from "../../../assets/images/Monuments Images/Nanded division/District Latur/Goddess Temple/l4.jpg"
import bhognarsimhaandramlingtemple from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Bhog Narasimha Temple and Ramalinga Temple/n18.jpg"
import gurdwara from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Gurdwara/n4.jpg"
import idgah from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Idgah/n1.jpg"
import kandaharfort1 from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Kandahar Fort/n03.jpg"
import kshtrapaltempleruin1 from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Kshetrapal temple ruins/n031.jpg"
import maturitirthlake from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Maturitirth Lake/n20.jpg"
import mahadevtemplenanded1 from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Mahadev Temple/n21.jpg"
import mahadevtemplenanded2 from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Mahadev Temple 1/n13.jpg"
import mahurfort1 from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Mahur Fort/n024.jpg"
import nandagirifort1 from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Nandagiri Fort/n07.jpg"
import nanditemplekund from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Nandi Temple and Kund/n9.jpg"
import nanditemple from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Nandi and the remains of the temple/n8.jpg"
import narasimhatemplecomplex from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Narasimha Temple Complex/n12.jpg"
import parameshwarmandir from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Parameshwar Mandir/n17.jpg"
import renukadevitemple from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Renukadevi Temple/n26.jpg"
import sonapirdargah from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Sonapir Dargah/n27.jpg"
import yoganrisimhatemple from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Yoganrisimha Temple/n25.jpg"
import zainuddinrafaidargah1 from "../../../assets/images/Monuments Images/Nanded division/District Nanded/District Nanded/Zainuddin Rafai Dargah/n029.jpg"
import gokuleshwartemplebarav1 from "../../../assets/images/Monuments Images/Nanded division/District Parbhani/Gokuleshwar Temple and Barav/003.jpg"
import gupteshwar1 from "../../../assets/images/Monuments Images/Nanded division/District Parbhani/Gupteshwar/004.jpg"
import jamamasjid from "../../../assets/images/Monuments Images/Nanded division/District Parbhani/Jama Masjid/10.jpg"
import mahadevtemplearadeshwar from "../../../assets/images/Monuments Images/Nanded division/District Parbhani/Mahadev Temple Aradeshwar/18.jpg"
import pathrifort from "../../../assets/images/Monuments Images/Nanded division/District Parbhani/Pathri Fort/16.jpg"
import roshankhanstomb from "../../../assets/images/Monuments Images/Nanded division/District Parbhani/Roshan Khan's tomb/19.png"
import ukhandeshwartemple1 from "../../../assets/images/Monuments Images/Nanded division/District Parbhani/Ukandeshwar Temple/01.jpg"
import kalabhairavatemplegondia from "../../../assets/images/Monuments Images/Nagpur division/District Gondia/Kalabhairava Temple/NewMonument.jpg"
import bhavanitemplechandrapur from "../../../assets/images/Monuments Images/Nagpur division/District Chandrapur/Bhavani Temple/c2.jpg"
import mahadevtemplebhatala from "../../../assets/images/Monuments Images/Nagpur division/District Chandrapur/Mahadev Temple, Bhatala/c4.jpg"
import manikgadfort from "../../../assets/images/Monuments Images/Nagpur division/District Chandrapur/Manikgad Fort/c3.jpg"
import rishilakecave from "../../../assets/images/Monuments Images/Nagpur division/District Chandrapur/Rishi Lake (Cave)/c1.jpg"
import shankartemple from "../../../assets/images/Monuments Images/Nagpur division/District Chandrapur/Shankar Temple/c5.jpg"
import someshwartemple from "../../../assets/images/Monuments Images/Nagpur division/District Chandrapur/Someshwar Temple/c6.jpg"

// Palghar Images .
import shirgaon from "../../../assets/images/Monuments Images/Ratnagiri division/District Palghar/Shirgaon Fort/shirgav 3.JPG"

// Mumbai Images  
import august from "../../../assets/images/Monuments Images/Ratnagiri division/District Mumbai/August Revolution/1.jpg"
import banganga from "../../../assets/images/Monuments Images/Ratnagiri division/District Mumbai/Banganga Lake/4.jpg"
import dean from "../../../assets/images/Monuments Images/Ratnagiri division/District Mumbai/Dean Bungalow/1.jpg"
import dharavi from "../../../assets/images/Monuments Images/Ratnagiri division/District Mumbai/Dharavi Fort/3.jpg"
import gateway from "../../../assets/images/Monuments Images/Ratnagiri division/District Mumbai/Gateway of India/3.jpg"
import mahim from "../../../assets/images/Monuments Images/Ratnagiri division/District Mumbai/Mahim Fort/1.jpg"
import sewri from "../../../assets/images/Monuments Images/Ratnagiri division/District Mumbai/Sewri Fort/3.jpg"
import stfort from "../../../assets/images/Monuments Images/Ratnagiri division/District Mumbai/Fort St. George/4.jpg"
import worli from "../../../assets/images/Monuments Images/Ratnagiri division/District Mumbai/Worli Fort/2.jpg"
import bandra from "../../../assets/images/Monuments Images/Ratnagiri division/District Mumbai/Bandra Fort/1 (1).jpg"

// Thane Images 
import ghodbunder from "../../../assets/images/Monuments Images/Ratnagiri division/District Thane/Ghodbunder Fort/4 (2).jpg"
import lonad from "../../../assets/images/Monuments Images/Ratnagiri division/District Thane/KhandeshwariLonad Caves/3.jpg"

// Sindhudurg Images 
import bharatgad from "../../../assets/images/Monuments Images/Ratnagiri division/District Sindhudurg/Bharatgad Fort/2.jpg"
import dutch from "../../../assets/images/Monuments Images/Ratnagiri division/District Sindhudurg/Dutch warehouse/1.jpg"
import yashvantgad from "../../../assets/images/Monuments Images/Ratnagiri division/District Sindhudurg/Yashwantgarh Fort/3.jpg"

// Raigad Images  
import karnala from "../../../assets/images/Monuments Images/Ratnagiri division/District Raigad/Karnala Fort/_____________________.jpg"
import khanderi from "../../../assets/images/Monuments Images/Ratnagiri division/District Raigad/Khanderi Fort/_____________________ (1).jpg"
import kanhoji from "../../../assets/images/Monuments Images/Ratnagiri division/District Raigad/Sarkhel Kanhoji Angre Samadhi/_______________.jpg"
import underi from "../../../assets/images/Monuments Images/Ratnagiri division/District Raigad/Underi Fort/_____________________________________.jpg"
import vasudev from "../../../assets/images/Monuments Images/Ratnagiri division/District Raigad/Vasudev Balwant Phadke Birthplace/_____________________________________ (1).jpg"

import bankotfort from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Bankot Fort/3.jpg"
import barsufort from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Barsu Carving/11.jpg"
import carvingdevihasol from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Carving at Devihasol/6.jpg"
import carvingchave from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Carvings at Chave/8.jpg"
import claykasheli from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Clay sculpture at Kasheli/15.jpg"
import deudsculpting from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Deud Sculpting/14.jpg"
import goafort from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Goa Fort/goa4.jpg"
import gopalgadfort from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Gopalgad Fort/7.jpg"
import karneshwartemple from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Karneshwar Temple/karneshwar 1.jpeg"
import khedcavs from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Khed Caves/1 (1).jpg"
import leatherkapadgaon from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Leather crafts at Kapadgaon/10.jpg"
import potteryrundhetli from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Pottery at RundhetliWadirundhe/9.jpg"
import purangadfort from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Purnagad/1.jpg"
import rasalgadfort from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Rasalgad/5.jpg"
import elephatukshi from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/The elephant at Ukshi/16.jpg"
import thebespalace from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Thebes Palace/thiba 2.jpg"
import tombofking from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Tomb of the King and Queen of Thebes/10.jpg"
import yashwantgadfort from "../../../assets/images/Monuments Images/Ratnagiri division/District Ratnagiri/Yashwantgad/4.jpg"
import Dummyimg from "../../../assets/images/Monuments Images/Dummyimage.png";
import mangadfort1 from "../../../assets/images/Monuments Images/Ratnagiri division/District Raigad/Mangad fort/mangad photo 1.jpeg"

const districtData = {
  palghar: {
    English: {
      title: "Palghar District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "RATNAGIRI DIVISION",
      divisionTitle: "PALGHAR DISTRICT",
      cards: [
        {
          id: "panagarhi-fort",
          title: "Pangadhi Fort",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "shirgaon-fort",
          title: "Shirgaon Fort",
          button: "Learn More",
          imageGroup: [shirgaon],
        },
      ],
    },
    मराठी: {
      title: "पालघर जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "रत्नागिरी विभाग",
      divisionTitle: "पालघर जिल्हा",
      cards: [
        {
          id: "panagarhi-fort",
          title: "पानगढी किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "shirgaon-fort",
          title: "शिरगाव किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [img3],
        },
      ],
    },
  },

  // Raigad District
  raigad: {
    English: {
      title: "Raigad District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "RATNAGIRI DIVISION",
      divisionTitle: "RAIGAD DISTRICT",
      cards: [
        {
          id: "karnala-fort",
          title: "Karnala Fort",
          button: "Learn More",
          imageGroup: [karnala],
        },
        {
          id: "khanderi-fort",
          title: "Khanderi Fort",
          button: "Learn More",
          imageGroup: [khanderi],
        },
        {
          id: "mangad-fort",
          title: "Mangad Fort",
          button: "Learn More",
          imageGroup: [mangadfort1],
        },
        {
          id: "sarkhel-kanhoji-angre-samadhi",
          title: "Sarkhel Kanhoji Angre Samadhi",
          button: "Learn More",
          imageGroup: [kanhoji],
        },
        {
          id: "underi-fort",
          title: "Underi Fort",
          button: "Learn More",
          imageGroup: [underi],
        },
        {
          id: "vasudev-balwant-phadke-birthplace",
          title: "Vasudev Balwant Phadke Birthplace",
          button: "Learn More",
          imageGroup: [vasudev],
        },
      ],
    },
    मराठी: {
      title: "रायगड जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "रत्नागिरी विभाग",
      divisionTitle: "रायगड जिल्हा",
      cards: [
        {
          id: "karnala-fort",
          title: "कर्नाळा किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [karnala],
        },
        {
          id: "khanderi-fort",
          title: "खांदेरी किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [khanderi],
        },
        {
          id: "mangad-fort",
          title: "मांगड किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [mangadfort1],
        },
        {
          id: "sarkhel-kanhoji-angre-samadhi",
          title: "सरखेल कान्होजी आंग्रे समाधी",
          button: "अधिक जाणून घ्या",
          imageGroup: [kanhoji],
        },
        {
          id: "underi-fort",
          title: "उंदेरी किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [underi],
        },
        {
          id: "vasudev-balwant-phadke-birthplace",
          title: "वासुदेव बळवंत फडके जन्मस्थान",
          button: "अधिक जाणून घ्या",
          imageGroup: [vasudev],
        },
      ],
    },
  },


  thane: {
    English: {
      title: "Thane District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "RATNAGIRI DIVISION",
      divisionTitle: "THANE DISTRICT",
      cards: [
        {
          id: "ghodbandar-fort",
          title: "Ghodbunder Fort",
          button: "Learn More",
          imageGroup: [ghodbunder],
        },
        {
          id: "lonad-caves",
          title: "Khandeshwari Caves",
          button: "Learn More",
          imageGroup: [lonad],
        },
      ],
    },
    मराठी: {
      title: "ठाणे जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "रत्नागिरी विभाग",
      divisionTitle: "ठाणे जिल्हा",
      cards: [
        {
          id: "ghodbandar-fort",
          title: "घोडबंदर किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [ghodbunder],
        },
        {
          id: "lonad-caves",
          title: "खंडेश्वरी लेणी",
          button: "अधिक जाणून घ्या",
          imageGroup: [lonad],
        },
      ],
    },
  },


  // Ratnagiri District
  ratnagiri: {
    English: {
      title: "Ratnagiri District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "RATNAGIRI DIVISION",
      divisionTitle: "RATNAGIRI DISTRICT",
      cards: [
        {
          id: "bankot-fort",
          title: "Bankot Fort",
          button: "Learn More",
          imageGroup: [bankotfort],
        },
        {
          id: "barsu-carving",
          title: "Barsu No. 2 Petroglyph",
          button: "Learn More",
          imageGroup: [barsufort],
        },
        {
          id: "carving-at-bhagwatinagar",
          title: "Bhagavatinagar Petroglyph",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "khed-caves",
          title: "Buddhist Caves",
          button: "Learn More",
          imageGroup: [khedcavs],
        },
        {
          id: "carvings-at-chave",
          title: "Chave Petroglyph",
          button: "Learn More",
          imageGroup: [carvingchave],
        },
        {
          id: "deud-sculpting",
          title: "Deod Petroglyph",
          button: "Learn More",
          imageGroup: [deudsculpting],
        },
        {
          id: "carving-at-devihasol",
          title: "Devihasol Petroglyph",
          button: "Learn More",
          imageGroup: [carvingdevihasol],
        },
        {
          id: "gopalgad-fort",
          title: "Gopalgad",
          button: "Learn More",
          imageGroup: [gopalgadfort],
        },
        {
          id: "goa-fort",
          title: "Goa Fort",
          button: "Learn More",
          imageGroup: [goafort],
        },
        {
          id: "leather-crafts-at-kapadgaon",
          title: "Kapadgaon Petroglyph",
          button: "Learn More",
          imageGroup: [leatherkapadgaon],
        },
        {
          id: "karneshwar-temple",
          title: "Karneshwar Temple",
          button: "Learn More",
          imageGroup: [karneshwartemple],
        },
        {
          id: "clay-sculpture-at-kasheli",
          title: "Kasheli Petroglyph",
          button: "Learn More",
          imageGroup: [claykasheli],
        },
        {
          id: "lokmanya-tilak",
          title: "Lokmanya Tilak Birthplace",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahipatgad-fort",
          title: "Mahipatgad Fort",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "purnagad",
          title: "Purnagad",
          button: "Learn More",
          imageGroup: [purangadfort],
        },
        {
          id: "rasalgad",
          title: "Rasalgad",
          button: "Learn More",
          imageGroup: [rasalgadfort],
        },
        {
          id: "tomb-of-the-king-queens",
          title: "Thibaw King and Queen's Tomb",
          button: "Learn More",
          imageGroup: [tombofking],
        },
        {
          id: "thebes-palace",
          title: "Thebes Palace",
          button: "Learn More",
          imageGroup: [thebespalace],
        },
        {
          id: "the-elephant-at-ukshi",
          title: "Ukshi Petroglyph",
          button: "Learn More",
          imageGroup: [elephatukshi],
        },
        {
          id: "pottery-at-rundhetli",
          title: "Wadi Rundhe Petroglyph",
          button: "Learn More",
          imageGroup: [potteryrundhetli],
        },
        {
          id: "yashwantgad",
          title: "Yashwantgad",
          button: "Learn More",
          imageGroup: [yashwantgadfort],
        },
      ],
    },
    मराठी: {
      title: "रत्नागिरी जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "रत्नागिरी विभाग",
      divisionTitle: "रत्नागिरी जिल्हा",
      cards: [
        {
          id: "bankot-fort",
          title: "बाणकोट किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [bankotfort],
        },
        {
          id: "barsu-carving",
          title: "बारसू २ कातळशिल्प",
          button: "अधिक जाणून घ्या",
          imageGroup: [barsufort],
        },
        {
          id: "carving-at-bhagwatinagar",
          title: "भगवतीनगर कातळशिल्प",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "khed-caves",
          title: "बौद्ध लेणी",
          button: "अधिक जाणून घ्या",
          imageGroup: [khedcavs],
        },
        {
          id: "deud-sculpting",
          title: "देऊड कातळशिल्प",
          button: "अधिक जाणून घ्या",
          imageGroup: [deudsculpting],
        },
        {
          id: "gopalgad-fort",
          title: "गोपाळगड",
          button: "अधिक जाणून घ्या",
          imageGroup: [gopalgadfort],
        },
        {
          id: "goa-fort",
          title: "गोवा किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [goafort],
        },
        {
          id: "leather-crafts-at-kapadgaon",
          title: "कापडगाव कातळशिल्प",
          button: "अधिक जाणून घ्या",
          imageGroup: [leatherkapadgaon],
        },
        {
          id: "karneshwar-temple",
          title: "कर्णेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [karneshwartemple],
        },
        {
          id: "clay-sculpture-at-kasheli",
          title: "कशेळी कातळशिल्प",
          button: "अधिक जाणून घ्या",
          imageGroup: [claykasheli],
        },
        {
          id: "lokmanya-tilak",
          title: "लोकमान्य टिळक",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahipatgad-fort",
          title: "महिपतगड किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "purnagad",
          title: "पूर्णगड",
          button: "अधिक जाणून घ्या",
          imageGroup: [purangadfort],
        },
        {
          id: "rasalgad",
          title: "रसाळगड",
          button: "अधिक जाणून घ्या",
          imageGroup: [rasalgadfort],
        },
        {
          id: "tomb-of-the-king-queens",
          title: "थिबा राजा आणि राणीची थडगे",
          button: "अधिक जाणून घ्या",
          imageGroup: [tombofking],
        },
        {
          id: "thebes-palace",
          title: "थिबा राजवाडा",
          button: "अधिक जाणून घ्या",
          imageGroup: [thebespalace],
        },
        {
          id: "the-elephant-at-ukshi",
          title: "उक्षी कातळशिल्प",
          button: "अधिक जाणून घ्या",
          imageGroup: [elephatukshi],
        },
        {
          id: "pottery-at-rundhetli",
          title: "वाडीरुंढे कातळशिल्प",
          button: "अधिक जाणून घ्या",
          imageGroup: [potteryrundhetli],
        },
        {
          id: "yashwantgad",
          title: "यशवंतगड",
          button: "अधिक जाणून घ्या",
          imageGroup: [yashwantgadfort],
        },
        {
          id: "carving-at-devihasol",
          title: "देवीहसोळ कातळशिल्प",
          button: "अधिक जाणून घ्या",
          imageGroup: [carvingdevihasol],
        },
        {
          id: "carvings-at-chave",
          title: "चवे कातळशिल्प",
          button: "अधिक जाणून घ्या",
          imageGroup: [carvingchave],
        },
      ],
    },
  },

  pune: {
    English: {
      title: "Pune District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "PUNE DIVISION",
      divisionTitle: "PUNE DISTRICT",
      cards: [
        {
          id: "buddhist-caves",
          title: "Bhandara Mountain Group of Buddhist Caves",
          button: "Learn More",
          imageGroup: [Dummyimg],
        }, {
          id: "copper-age-settlement",
          title: "Chalcolithic Settlement",
          button: "Learn More",
          imageGroup: [copper],
        }, {
          id: "martyr-rajguru-wada",
          title: "Hutatma Rajgur wada ",
          button: "Learn More",
          imageGroup: [martyr],
        }, {
          id: "khandoba-temple",
          title: "Khandoba Temple",
          button: "Learn More",
          imageGroup: [khandoba],
        }, {
          id: "koirigarh-fort",
          title: "Koyrigad Fort",
          button: "Learn More",
          imageGroup: [korigad1],
        }, {
          id: "kukdeswar-temple",
          title: "Kukdeswar Temple",
          button: "Learn More",
          imageGroup: [kukdeswar],
        }, {
          id: "mahadev-temple",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [mahadev],
        }, {
          id: "mahadev-temple-and-Datta-temple-complex",
          title: "Mahadeo Temple and Datta Temple Complex",
          button: "Learn More",
          imageGroup: [mahadevandtula],
        }, {
          id: "mahatma-phule-wada",
          title: "Mahatma Phule Wada",
          button: "Learn More",
          imageGroup: [mahatmaphule],
        }, {
          id: "mastani-tomb",
          title: "Mastani Tomb",
          button: "Learn More",
          imageGroup: [mastani11],
        }, {
          id: "nageshwar-temple",
          title: "Nageshwar Temple",
          button: "Learn More",
          imageGroup: [nagehswar],
        }, {
          id: "narasimha-temple",
          title: "Narasimha Temple",
          button: "Learn More",
          imageGroup: [narasimha],
        }, {
          id: "raireshwar-temple",
          title: "Raireshwar Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        }, {
          id: "Rajgad Fort",
          title: "Rajgad Fort",
          button: "Learn More",
          imageGroup: [raigad],
        }, {
          id: "st-cripsins-church",
          title: "Saint Krispin Church",
          button: "Learn More",
          imageGroup: [cripsins],
        }, {
          id: "sambhaji-maharajs-tomb",
          title: "Sambhaji Maharaj Samadhi",
          button: "Learn More",
          imageGroup: [sambhaji],
        }, {
          id: "sangramdurg-fort",
          title: "Sangramdurg Fort",
          button: "Learn More",
          imageGroup: [sangramdurg],
        }, {
          id: "santaji-jagannath-maharajs-tomb",
          title: "Santaji Jagannath Maharaj Samadhi",
          button: "Learn More",
          imageGroup: [santaji],
        }, {
          id: "sardar-kanhoji-jedhe-wada",
          title: "Sardar Kanhoji Jedhe Wada",
          button: "Learn More",
          imageGroup: [sardarkanoji],
        }, {
          id: "sinhagad-fort",
          title: "Sinhagad Fort",
          button: "Learn More",
          imageGroup: [sinhagad],
        }, {
          id: "tanaji-malusare-samadhi",
          title: "Tanaji Malusare Samadhi",
          button: "Learn More",
          imageGroup: [tanajimalusare],
        }, {
          id: "torna-fort",
          title: "Torna  Fort",
          button: "Learn More",
          imageGroup: [torna],
        }, {
          id: "vishrambaug-wada",
          title: "Vishrambaug Wada",
          button: "Learn More",
          imageGroup: [vishrambaug],
        }, {
          id: "pandavdara-caves",
          title: "Pandavdara Caves",
          button: "Learn More",
          imageGroup: [pandavdara],
        },
        // {
        //   id: "panhala-fort",
        //   title: "Panhala Fort",
        //   button: "Learn More",
        //   imageGroup: [img3],
        // },
      ],
    },
    मराठी: {
      title: "पुणे जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "पुणे विभाग",
      divisionTitle: "पुणे जिल्हा",
      cards: [
        {
          id: "buddhist-caves",
          title: "भंडारा बौद्ध लेणी समूह",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        }, {
          id: "copper-age-settlement",
          title: "ताम्रपाषण युगीन वसाहत",
          button: "अधिक जाणून घ्या",
          imageGroup: [copper],
        }, {
          id: "martyr-rajguru-wada",
          title: "हुतात्मा राजगुरू वाडा",
          button: "अधिक जाणून घ्या",
          imageGroup: [martyr],
        }, {
          id: "khandoba-temple",
          title: "खंडोबा मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [khandoba],
        }, {
          id: "koirigarh-fort",
          title: "कोयरीगड किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [korigad1],
        }, {
          id: "kukdeswar-temple",
          title: "कुकडेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [kukdeswar],
        }, {
          id: "mahadev-temple",
          title: "महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahadev],
        }, {
          id: "mahadev-temple-and-Datta-temple-complex",
          title: "महादेव मंदिर आणि दत्त मंदिर संकुल",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahadevandtula],
        }, {
          id: "mahatma-phule-wada",
          title: "महात्मा फुले वाडा",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahatmaphule],
        }, {
          id: "mastani-tomb",
          title: "मस्तानी कबर",
          button: "अधिक जाणून घ्या",
          imageGroup: [mastani11],
        }, {
          id: "nageshwar-temple",
          title: "नागेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [nagehswar],
        }, {
          id: "narasimha-temple",
          title: "नरसिंह मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [narasimha],
        }, {
          id: "raireshwar-temple",
          title: "रायरेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [img3],
        }, {
          id: "Rajgad Fort",
          title: "राजगड किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [raigad],
        }, {
          id: "st-cripsins-church",
          title: "संत क्रिस्पिन चर्च",
          button: "अधिक जाणून घ्या",
          imageGroup: [cripsins],
        }, {
          id: "sambhaji-maharajs-tomb",
          title: "संभाजी महाराज समाधी",
          button: "अधिक जाणून घ्या",
          imageGroup: [sambhaji],
        }, {
          id: "sangramdurg-fort",
          title: "संग्रामदुर्ग किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [sangramdurg],
        }, {
          id: "santaji-jagannath-maharajs-tomb",
          title: "संताजी जगन्नाथ महाराज समाधी",
          button: "अधिक जाणून घ्या",
          imageGroup: [santaji],
        }, {
          id: "sardar-kanhoji-jedhe-wada",
          title: "सरदार कान्होजी जेधे वाडा",
          button: "अधिक जाणून घ्या",
          imageGroup: [sardarkanoji],
        }, {
          id: "sinhagad-fort",
          title: "सिंहगड किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [sinhagad],
        }, {
          id: "tanaji-malusare-samadhi",
          title: "तानाजी मालुसरे समाधी",
          button: "अधिक जाणून घ्या",
          imageGroup: [tanajimalusare],
        }, {
          id: "torna-fort",
          title: "तोरणा किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [torna],
        }, {
          id: "vishrambaug-wada",
          title: "विश्रामबाग वाडा",
          button: "अधिक जाणून घ्या",
          imageGroup: [vishrambaug],
        }, {
          id: "pandavdara-caves",
          title: "पांडवदरा लेणी",
          button: "अधिक जाणून घ्या",
          imageGroup: [pandavdara],
        },
        // {
        //   id: "panhala-fort",
        //   title: "पन्हाळा किल्ला",
        //   button: "अधिक जाणून घ्या",
        //   imageGroup: [img3],
        // },
      ]
    },
  },

  satara: {
    English: {
      title: "Satara District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "PUNE DIVISION",
      divisionTitle: "SATARA DISTRICT",
      cards: [
        {
          id: "bhairavanath-temple",
          title: "Bhairavanath Temple",
          button: "Learn More",
          imageGroup: [bhairavanath],
        },
        {
          id: "dr-babasaheb-ambedkar-residence",
          title: "Dr. Babasaheb Ambedkar Residence",
          button: "Learn More",
          imageGroup: [drbabasaheb],
        },
        {
          id: "pratapgad-fort",
          title: "Pratapgad Fort",
          button: "Learn More",
          imageGroup: [pratapgad],
        },
        {
          id: "tomb-of-sir-senapati-hambirrao-mohite",
          title: "Sir Senapati Hambirrao Mohite Samadhi",
          button: "Learn More",
          imageGroup: [senapatihambirrao],
        },
        {
          id: "birthplace-of-savitribai-phule",
          title: "Savitribai Phule Birthplace",
          button: "Learn More",
          imageGroup: [savitribai],
        },
        {
          id: "vasudeva-swamy-math",
          title: "Vasudeva Swami Math",
          button: "Learn More",
          imageGroup: [vasudeva],
        },
        {
          id: "maharani-yesubais-tomb",
          title: "Maharani Yesubai Samadhi",
          button: "Learn More",
          imageGroup: [maharaniyesubai],
        },

      ],
    },
    मराठी: {
      title: "सातारा जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "सातारा विभाग",
      divisionTitle: "सातारा जिल्हा",
      cards: [
        {
          id: "bhairavanath-temple",
          title: "भैरवनाथ मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [bhairavanath],
        },
        {
          id: "dr-babasaheb-ambedkar-residence",
          title: "डॉ. बाबासाहेब आंबेडकर निवासस्थान",
          button: "अधिक जाणून घ्या",
          imageGroup: [drbabasaheb],
        },
        {
          id: "pratapgad-fort",
          title: "प्रतापगड किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [pratapgad],
        },
        {
          id: "tomb-of-sir-senapati-hambirrao-mohite",
          title: "सर सेनापती हंबीरराव मोहिते समाधी",
          button: "अधिक जाणून घ्या",
          imageGroup: [senapatihambirrao],
        },
        {
          id: "birthplace-of-savitribai-phule",
          title: "सावित्रीबाई फुले जन्मस्थान",
          button: "अधिक जाणून घ्या",
          imageGroup: [savitribai],
        },
        {
          id: "vasudeva-swamy-math",
          title: "वासुदेव स्वामी मठ",
          button: "अधिक जाणून घ्या",
          imageGroup: [vasudeva],
        },
        {
          id: "maharani-yesubais-tomb",
          title: "महाराणी येसुबाई समाधी",
          button: "अधिक जाणून घ्या",
          imageGroup: [maharaniyesubai],
        },

      ]
    }
  },

  solapur: {
    English: {
      title: "Solapur District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "PUNE DIVISION",
      divisionTitle: "SOLAPUR DISTRICT",
      cards: [
        {
          id: "mahadev-temple-solapur",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [mahadevtemplesolapur],
        },
        {
          id: "sangameshwar-muralidhar-temple",
          title: "Sangameshwar and Muralidhar Temple",
          button: "Learn More",
          imageGroup: [sangameshwar],
        },
        {
          id: "madha-fort",
          title: "Madha Fort",
          button: "Learn More",
          imageGroup: [madhafort],
        },
        {
          id: "mangalveda-fort",
          title: "Mangalveda Fort",
          button: "Learn More",
          imageGroup: [mangalveda],
        },
      ],
    },
    मराठी: {
      title: "सोलापूर जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "सोलापूर विभाग",
      divisionTitle: "सोलापूर जिल्हा",
      cards: [
        {
          id: "mahadev-temple-solapur",
          title: "महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahadevtemplesolapur],
        },
        {
          id: "sangameshwar-muralidhar-temple",
          title: "संगमेश्वर व मुरलीधर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [sangameshwar],
        },
        {
          id: "madha-fort",
          title: "माढा किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [madhafort],
        },
        {
          id: "mangalveda-fort",
          title: "मंगळवेढा किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [mangalveda],
        },
      ]
    }
  },

  sangli: {
    English: {
      title: "Sangli District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "PUNE DIVISION",
      divisionTitle: "SANGLI DISTRICT",
      cards: [
        {
          id: "kalmadevi-temple",
          title: "Kallamma devi Temple",
          button: "Learn More",
          imageGroup: [kalmadevi],
        },
        {
          id: "yashwantrao-chavan-birthplace",
          title: "Yashwantrao Chavan Birthplace",
          button: "Learn More",
          imageGroup: [yashwantrao],
        },
      ]
    },
    मराठी: {
      title: "सांगली जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "सांगली विभाग",
      divisionTitle: "सांगली जिल्हा",
      cards: [
        {
          id: "kalmadevi-temple",
          title: "कल्लमादेवी  मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [kalmadevi],
        },
        {
          id: "yashwantrao-chavan-birthplace",
          title: "यशवंतराव चव्हाण यांचे जन्मस्थान",
          button: "अधिक जाणून घ्या",
          imageGroup: [yashwantrao],
        },
      ]
    }
  },

  kolhapur: {
    English: {
      title: "Kolhapur District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "PUNE DIVISION",
      divisionTitle: "kOLHAPUR DISTRICT",
      cards: [
        {
          id: "bajiprabhu-and-phulajiprabhu-deshpandes-tomb",
          title: "Bajiprabhu and Phulaji Prabhu Deshpande Samadhi",
          button: "Learn More",
          imageGroup: [bajiprabhu],
        },
        {
          id: "bhudargad-fort",
          title: "Bhudargad Fort",
          button: "Learn More",
          imageGroup: [bhudargad],
        },
        {
          id: "lakshmi-vilas-palace",
          title: "Lakshmi Vilas Palace",
          button: "Learn More",
          imageGroup: [lakshmivilas],
        },
        {
          id: "mahadev-temple-kolhapur",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [kolhapurmahadev],
        },
        {
          id: "pandava-pass-shaiva-caves",
          title: "Pandavdara Shaiva Caves",
          button: "Learn More",
          imageGroup: [pandavapas],
        },

        {
          id: "crawling-fort",
          title: "Raangana",
          button: "Learn More",
          imageGroup: [crawling],
        },
        {
          id: "ramachandra-pant-amatya-samadhi",
          title: "Ramachandra Pant Amatya Samadhi",
          button: "Learn More",
          imageGroup: [ramachandra],
        },
        {
          id: "vishalgad",
          title: "Vishalgad",
          button: "Learn More",
          imageGroup: [vishalgad],
        },
      ]
    },
    मराठी: {
      title: "कोल्हापूर जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "कोल्हापूर विभाग",
      divisionTitle: "कोल्हापूर जिल्हा",
      cards: [
        {
          id: "bajiprabhu-and-phulajiprabhu-deshpandes-tomb",
          title: "बाजीप्रभू आणि फुलाजीप्रभू देशपांडे समाधी",
          button: "अधिक जाणून घ्या",
          imageGroup: [bajiprabhu],
        },
        {
          id: "bhudargad-fort",
          title: "भुदरगड",
          button: "अधिक जाणून घ्या",
          imageGroup: [bhudargad],
        },
        {
          id: "lakshmi-vilas-palace",
          title: "लक्ष्मी विलास राजवाडा",
          button: "अधिक जाणून घ्या",
          imageGroup: [lakshmivilas],
        },
        {
          id: "mahadev-temple-kolhapur",
          title: "महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [kolhapurmahadev],
        },
        {
          id: "pandava-pass-shaiva-caves",
          title: "पांडवदरा शैव लेणी",
          button: "अधिक जाणून घ्या",
          imageGroup: [pandavapas],
        },
        {
          id: "crawling-fort",
          title: "रांगणा किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [crawling],
        },
        {
          id: "ramachandra-pant-amatya-samadhi",
          title: "रामचंद्र पंत अमात्य समाधी",
          button: "अधिक जाणून घ्या",
          imageGroup: [ramachandra],
        },
        {
          id: "vishalgad",
          title: "विशाळगड",
          button: "अधिक जाणून घ्या",
          imageGroup: [vishalgad],
        },
      ]
    }
  },

  mumbai: {
    English: {
      title: "Mumbai District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "RATNAGIRI DIVISION",
      divisionTitle: "MUMBAI DISTRICT",
      cards: [
        {
          id: "august-revolution",
          title: "August Kranti Maidan",
          button: "Learn More",
          imageGroup: [august],
        },
        {
          id: "banganga-lake",
          title: "Banganga Lake",
          button: "Learn More",
          imageGroup: [banganga],
        },
        {
          id: "dean-bungalow",
          title: "Dean Bungalow (Rudyard Kipling)",
          button: "Learn More",
          imageGroup: [dean],
        },
        {
          id: "dharavi-fort",
          title: "Dharavi Fort",
          button: "Learn More",
          imageGroup: [dharavi],
        },
        {
          id: "gateway-of-India",
          title: "Gateway of India",
          button: "Learn More",
          imageGroup: [gateway],
        },
        {
          id: "mahim-fort",
          title: "Mahim Fort",
          button: "Learn More",
          imageGroup: [mahim],
        },
        {
          id: "sewri-fort",
          title: "Sewri Fort",
          button: "Learn More",
          imageGroup: [sewri],
        },
        {
          id: "fort-st-george",
          title: "St. George Fort ",
          button: "Learn More",
          imageGroup: [stfort],
        },
        {
          id: "worli-fort",
          title: "Worli Fort",
          button: "Learn More",
          imageGroup: [worli],
        },
        // {
        //   id: "fort-george",
        //   title: "Fort George",
        //   button: "Learn More",
        //   imageGroup: [fort],
        // },
        {
          id: "bandra-fort",
          title: "Bandra Fort",
          button: "Learn More",
          imageGroup: [bandra],
        },
      ],
    },
    मराठी: {
      title: "मुंबई जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "रत्नागिरी विभाग",
      divisionTitle: "मुंबई जिल्हा",
      cards: [
        {
          id: "august-revolution",
          title: "ऑगस्ट क्रांती मैदान",
          button: "अधिक जाणून घ्या",
          imageGroup: [august],
        },
        {
          id: "banganga-lake",
          title: "बाणगंगा तलाव",
          button: "अधिक जाणून घ्या",
          imageGroup: [banganga],
        },
        {
          id: "dean-bungalow",
          title: "डीन बंगला",
          button: "अधिक जाणून घ्या",
          imageGroup: [dean],
        },
        {
          id: "dharavi-fort",
          title: "धारावी किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [dharavi],
        },
        {
          id: "gateway-of-India",
          title: "गेट वे ऑफ इंडिया",
          button: "अधिक जाणून घ्या",
          imageGroup: [gateway],
        },
        {
          id: "mahim-fort",
          title: "माहीम किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahim],
        },
        {
          id: "sewri-fort",
          title: "शिवडी किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [sewri],
        },
        {
          id: "fort-st-george",
          title: "सेंट जॉर्ज किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [stfort],
        },
        {
          id: "worli-fort",
          title: "वरळी किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [worli],
        },
        // {
        //   id: "fort-george",
        //   title: "फोर्ट जॉर्ज",
        //   button: "अधिक जाणून घ्या",
        //   imageGroup: [fort],
        // },
        {
          id: "bandra-fort",
          title: "बांद्रा किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [bandra],
        },
      ]
    }
  },


  sindhudurg: {
    English: {
      title: "Sindhudurg District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "RATNAGIRI DIVISION",
      divisionTitle: "SINDHUDURG DISTRICT",
      cards: [
        {
          id: "bharatgad-fort",
          title: "Bharatgad",
          button: "Learn More",
          imageGroup: [bharatgad],
        },
        {
          id: "dutch-warehouse",
          title: "Dutch factory",
          button: "Learn More",
          imageGroup: [dutch],
        },
        {
          id: "yashwantgarh-fort",
          title: "Yashwantgad",
          button: "Learn More",
          imageGroup: [yashvantgad],
        },
      ],
    },
    मराठी: {
      title: "सिंधुदुर्ग जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "रत्नागिरी विभाग",
      divisionTitle: "सिंधुदुर्ग जिल्हा",
      cards: [
        {
          id: "bharatgad-fort",
          title: "भरतगड",
          button: "अधिक जाणून घ्या",
          imageGroup: [bharatgad],
        },
        {
          id: "dutch-warehouse",
          title: "डच वखार",
          button: "अधिक जाणून घ्या",
          imageGroup: [dutch],
        },
        {
          id: "yashwantgarh-fort",
          title: "यशवंतगड",
          button: "अधिक जाणून घ्या",
          imageGroup: [yashvantgad],
        },
      ]
    }
  },


  nandurbar: {
    English: {
      title: "Nandurbar District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NASHIK DIVISION",
      divisionTitle: "NANDURBAR DISTRICT",
      cards: [
        {
          id: "jain-caves",
          title: "Jain Caves",
          button: "Learn More",
          imageGroup: [jaincaves1],
        },
      ],
    },
    मराठी: {
      title: "नंदुरबार जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नाशिक विभाग",
      divisionTitle: "नंदुरबार जिल्हा",
      cards: [
        {
          id: "jain-caves",
          title: "जैन लेणी",
          button: "अधिक जाणून घ्या",
          imageGroup: [jaincaves1],
        },
      ]
    }
  },

  //Jalgaon District
  jalgaon: {
    English: {
      title: "Jalgaon District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NASHIK DIVISION",
      divisionTitle: "JALGAON DISTRICT",
      cards: [
        {
          id: "hanging-towers",
          title: "Jhulte Manore",
          button: "Learn More",
          imageGroup: [hangingtowers1],
        },
        {
          id: "kapileshwar-temple",
          title: "Kapileshwar Temple",
          button: "Learn More",
          imageGroup: [kapileshwartemple1],
        },
        {
          id: "pandava-wada-mosque",
          title: "Pandav Wada Masjid",
          button: "Learn More",
          imageGroup: [pandavawadamosque1],
        },
        {
          id: "parola-fort",
          title: "Parola Fort",
          button: "Learn More",
          imageGroup: [parolafort1],
        },
        {
          id: "shiv-temple",
          title: "Shiva Temple",
          button: "Learn More",
          imageGroup: [shivatemple1],
        },
        {
          id: "ves",
          title: "Ves (Amalner Fort Gate and Bastion)",
          button: "Learn More",
          imageGroup: [Ves1],
        }
      ]
    },
    मराठी: {
      title: "जळगाव जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नाशिक विभाग",
      divisionTitle: "जळगाव जिल्हा",
      cards: [
        {
          id: "hanging-towers",
          title: "झुलते मनोरे",
          button: "अधिक जाणून घ्या",
          imageGroup: [hangingtowers1],
        },
        {
          id: "kapileshwar-temple",
          title: "कपिलेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [kapileshwartemple1],
        },
        {
          id: "pandava-wada-mosque",
          title: "पांडववाडा मस्जिद",
          button: "अधिक जाणून घ्या",
          imageGroup: [pandavawadamosque1],
        },
        {
          id: "parola-fort",
          title: "पारोळा किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [parolafort1],
        },
        {
          id: "shiv-temple",
          title: "शिव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [shivatemple1],
        },
        {
          id: "ves",
          title: "वेस (अमळनेर किल्ला)",
          button: "अधिक जाणून घ्या",
          imageGroup: [Ves1],
        },
      ]
    }
  },

  // DHULE DISTRICT 
  dhule: {
    English: {
      title: "Dhule District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NASHIK DIVISION",
      divisionTitle: "DHULE DISTRICT",
      cards: [
        {
          id: "bhavani-temple-dhule",
          title: "Bhavani Temple / Vishnu Temple (Balaji Temple)",
          button: "Learn More",
          imageGroup: [bhavanitempleandvishnutemple1],
        },
        {
          id: "harba-temple",
          title: "Harba Temple/Mahadeo Temple",
          button: "Learn More",
          imageGroup: [harbatemplemahadev1],
        },
        {
          id: "jain-temple",
          title: "Jain Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "kalikadevi-temple",
          title: "Kalikadevi Temple",
          button: "Learn More",
          imageGroup: [kalikadevitemple1],
        },
        {
          id: "laling-fort",
          title: "Laling Fort",
          button: "Learn More",
          imageGroup: [lalingfort1],
        },
      ],
    },
    मराठी: {
      title: "धुळे जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नाशिक विभाग",
      divisionTitle: "धुळे जिल्हा",
      cards: [
        {
          id: "bhavani-temple-dhule",
          title: "भवानी मंदिर आणि विष्णू मंदिर (बालाजी मंदिर)",
          button: "अधिक जाणून घ्या",
          imageGroup: [bhavanitempleandvishnutemple1],
        },
        {
          id: "harba-temple",
          title: "हरबा मंदिर/महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [harbatemplemahadev1],
        },
        {
          id: "jain-temple",
          title: "जैन मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "kalikadevi-temple",
          title: "कालिकादेवी मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [kalikadevitemple1],
        },
        {
          id: "laling-fort",
          title: "लळींग किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [lalingfort1],
        },
      ]
    }
  },

  // NASHIK DISTRICT 
  Nashik: {
    English: {
      title: "Nashik District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NASHIK DIVISION",
      divisionTitle: "NASHIK DISTRICT",
      cards: [
        {
          id: "ankai-fort",
          title: "Ankai Fort",
          button: "Learn More",
          imageGroup: [ankaifort1],
        },
        {
          id: "aranath-jain-caves",
          title: "Aranath Jain Temple",
          button: "Learn More",
          imageGroup: [aranathjaincaves1],
        },
        {
          id: "ballaleshwar-temple",
          title: "Ballaleshwar Temple",
          button: "Learn More",
          imageGroup: [ballaleshwartemple1],
        },
        {
          id: "galana-fort",
          title: "Galna Fort",
          button: "Learn More",
          imageGroup: [galanafort1],
        },
        {
          id: "hatgad-fort",
          title: "Hatgad Fort",
          button: "Learn More",
          imageGroup: [hatgadfort1],
        },
        {
          id: "indraleshwar-temple",
          title: "Indraleshwar Temple",
          button: "Learn More",
          imageGroup: [indraleshwartemple1],
        },
        {
          id: "jain-caves-kalika-temple",
          title: "Jain Caves (Kalika Temple)",
          button: "Learn More",
          imageGroup: [jaincaveskalikatemple1],
        },
        {
          id: "kushavarta-pilgrimage",
          title: "Kushavartha Tirth",
          button: "Learn More",
          imageGroup: [kushawarthpilgrimage1],
        },
        {
          id: "mahadev-temple-devlana",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [devlanamahadevmandir1],
        },
        {
          id: "mahadev-temple-deoli",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [mahadevtempledevalikarad1],
        },
        {
          id: "malegaon-fort",
          title: "Malegaon Fort",
          button: "Learn More",
          imageGroup: [malegaonfort1],
        },
        {
          id: "mukteshwar-mahadev-temple",
          title: "Mukteshwar Mahadeo Temple",
          button: "Learn More",
          imageGroup: [mukteshwarmahadevtemple1],
        },
        {
          id: "mulher-fort",
          title: "Mulher Fort",
          button: "Learn More",
          imageGroup: [mulherfort1],
        },
        {
          id: "neelkantheshwar-mahadev-temple",
          title: "Nilkhanteshwar Mahadeo Temple",
          button: "Learn More",
          imageGroup: [neelkantheshwarmahadevtemple1],
        },
        {
          id: "parswanath-jain-caves",
          title: "Parswanath Jain Caves",
          button: "Learn More",
          imageGroup: [parswanathjaincaves1],
        },
        {
          id: "raghaveshwar-mahadev-temple-nashik",
          title: "Raghaveshwar Mahadeo Temple",
          button: "Learn More",
          imageGroup: [raghaveshwarmahadevtemple1],
        },
        {
          id: "rangmahal-nashik",
          title: "Rangmahal",
          button: "Learn More",
          imageGroup: [rangmahal1],
        },
        {
          id: "renukadevi-temple-nashik",
          title: "Renukadevi Temple",
          button: "Learn More",
          imageGroup: [vishnutemple1],
        },
        {
          id: "salher-fort",
          title: "Salher Fort",
          button: "Learn More",
          imageGroup: [SalherFort1],
        },
        {
          id: "government-house",
          title: "Sarkarwada",
          button: "Learn More",
          imageGroup: [governmenthouse],
        },
        {
          id: "sundernarayan-temple",
          title: "Sundernarayan Temple",
          button: "Learn More",
          imageGroup: [SundernarayanTemple1],
        },
        {
          id: "swatantryaveer-savarkar's-birthplace-and-well",
          title: "Swatantryaveer Savarkar's Birthplace and Well",
          button: "Learn More",
          imageGroup: [swatantryaveersavarkar1],
        },
        {
          id: "tankai-fort",
          title: "Tankai Fort",
          button: "Learn More",
          imageGroup: [tankaifort1],
        },
        {
          id: "tatoba-temple",
          title: "Tatoba Temple",
          button: "Learn More",
          imageGroup: [tatobatemple1],
        },
        {
          id: "tribhuvaneshwar",
          title: "Tribhuvaneshwar",
          button: "Learn More",
          imageGroup: [tribhuvaneshwar1],
        },
        {
          id: "vaijeshwar-temple",
          title: "Vaijeshwar Mahadeo Temple",
          button: "Learn More",
          imageGroup: [vaijeshwartemple1],
        },
        {
          id: "vishnu-temple-nashik",
          title: "Vishnu Temple",
          button: "Learn More",
          imageGroup: [mahadevtemplesolapur],
        },
        {
          id: "vateswar-mahadev-temple",
          title: "Wateswar Mahadeo Temple",
          button: "Learn More",
          imageGroup: [vateswarmahadevtemple1],
        },
      ]
    },
    मराठी: {
      title: "नाशिक जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नाशिक विभाग",
      divisionTitle: "नाशिक जिल्हा",
      cards: [
        {
          id: "ankai-fort",
          title: "अंकाई किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [ankaifort1],
        },
        {
          id: "aranath-jain-caves",
          title: "अरनाथ जैन लेणी",
          button: "अधिक जाणून घ्या",
          imageGroup: [aranathjaincaves1],
        },
        {
          id: "ballaleshwar-temple",
          title: "बल्लाळेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [ballaleshwartemple1],
        },
        {
          id: "galana-fort",
          title: "गाळणा किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [galanafort1],
        },
        {
          id: "hatgad-fort",
          title: "हतगड किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [hatgadfort1],
        },
        {
          id: "indraleshwar-temple",
          title: "इंद्राळेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [indraleshwartemple1],
        },
        {
          id: "jain-caves-kalika-temple",
          title: "जैन लेणी (कालिका मंदिर)",
          button: "अधिक जाणून घ्या",
          imageGroup: [jaincaveskalikatemple1],
        },
        {
          id: "kushavarta-pilgrimage",
          title: "कुशावर्त तीर्थ",
          button: "Learn More",
          imageGroup: [kushawarthpilgrimage1],
        },
        {
          id: "mahadev-temple-devlana",
          title: "महादेव मंदिर, देवळाना",
          button: "अधिक जाणून घ्या",
          imageGroup: [devlanamahadevmandir1],
        },
        {
          id: "mahadev-temple-deoli",
          title: "महादेव मंदिर,देवळी कराड",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahadevtempledevalikarad1],
        },
        {
          id: "malegaon-fort",
          title: "मालेगाव किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [malegaonfort1],
        },
        {
          id: "mukteshwar-mahadev-temple",
          title: "मुक्तेश्वर महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [mukteshwarmahadevtemple1],
        },
        {
          id: "mulher-fort",
          title: "मुल्हेर किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [mulherfort1],
        },
        {
          id: "neelkantheshwar-mahadev-temple",
          title: "निळकंठेश्वर महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [neelkantheshwarmahadevtemple1],
        },
        {
          id: "parswanath-jain-caves",
          title: "पार्श्वनाथ जैन लेणी",
          button: "अधिक जाणून घ्या",
          imageGroup: [parswanathjaincaves1],
        },
        {
          id: "raghaveshwar-mahadev-temple-nashik",
          title: "राघवेश्वर महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [raghaveshwarmahadevtemple1],
        },
        {
          id: "rangmahal-nashik",
          title: "रंगमहाल",
          button: "अधिक जाणून घ्या",
          imageGroup: [rangmahal1],
        },
        {
          id: "renukadevi-temple-nashik",
          title: "रेणुकादेवी मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [renukadevitemple1],
        },
        {
          id: "salher-fort",
          title: "साल्हेर किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [SalherFort1],
        },
        {
          id: "government-house",
          title: "सरकारवाडा",
          button: "अधिक जाणून घ्या",
          imageGroup: [governmenthouse],
        },
        {
          id: "sundernarayan-temple",
          title: "सुंदरनारायण मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [SundernarayanTemple1],
        },
        {
          id: "swatantryaveer-savarkar's-birthplace-and-well",
          title: "स्वातंत्र्यवीर सावरकर जन्मस्थान आणि विहीर",
          button: "अधिक जाणून घ्या",
          imageGroup: [swatantryaveersavarkar1],
        },
        {
          id: "tankai-fort",
          title: "टंकाई किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [tankaifort1],
        },
        {
          id: "tatoba-temple",
          title: "तातोबा मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [tatobatemple1],
        },
        {
          id: "tribhuvaneshwar",
          title: "त्रिभुवनेश्वर",
          button: "अधिक जाणून घ्या",
          imageGroup: [tribhuvaneshwar1],
        },
        {
          id: "vaijeshwar-temple",
          title: "वैजेश्वर महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [vaijeshwartemple1],
        },
        {
          id: "vishnu-temple-nashik",
          title: "विष्णु मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [vishnutemple1],
        },
        {
          id: "vateswar-mahadev-temple",
          title: "वटेश्वर महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [vateswarmahadevtemple1],
        },
      ]
    }
  },


  ahilyanagar: {
    English: {
      title: "Ahilyanagar District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NASHIK DIVISION",
      divisionTitle: "AHILYANAGAR DISTRICT",
      cards: [
        {
          id: "birthplace-of-ahilyabai-holkar",
          title: "Garhi - Birthplace of Ahilyabai Holkar (and Sangha)",
          button: "Learn More",
          imageGroup: [ahilyabaitemple],
        },
        {
          id: "birthplace-of-ahilyabai-holkar-mahadev-temple",
          title: "Garhi - Birthplace of Ahilyabai Holkar (and Sangha) a) Mahadeo Temple",
          button: "Learn More",
          imageGroup: [mahadevtemple],
        },
        {
          id: "birthplace-of-ahilyabai-holkar-chondeshwari-temple",
          title: "Garhi - Birthplace of Ahilyabai Holkar (and Sangha) b) Chondeshwari Temple ",
          button: "Learn More",
          imageGroup: [chondeshwaritemple],
        },
        {
          id: "birthplace-of-ahilyabai-holkar-ahilyabai-temple",
          title: "Garhi - Birthplace of Ahilyabai Holkar (and Sangha) c) Ahilyabai Temple",
          button: "Learn More",
          imageGroup: [ahilyabaitemple],
        },
        {
          id: "harinarayan-math",
          title: "Harinarayan Math",
          button: "Learn More",
          imageGroup: [harinarayanamath1],
        },
        {
          id: "kharda-fort",
          title: "Kharda Fort",
          button: "Learn More",
          imageGroup: [khardafort1],
        },
        {
          id: "lakshmi-temple",
          title: "Lakshmi Temple",
          button: "Learn More",
          imageGroup: [lakshmitemple1],
        },
        {
          id: "nimbalkar-gadi",
          title: "Nimbalkar Gadi, Nimbalkar Chhatri, Omkareshwar Temple and Barav",
          button: "Learn More",
          imageGroup: [nimbalkargadhi1],
        },
        {
          id: "raghaveshwar-mahadev-temple",
          title: "Raghaveshwar Temple",
          button: "Learn More",
          imageGroup: [raghaveshwarmahadevtemple11],
        },
        {
          id: "raghobadada-wada",
          title: "Raghobadada Wada",
          button: "Learn More",
          imageGroup: [raghobadadawada1],
        },
        {
          id: "senapati-bapat",
          title: "Senapati Bapat Birthplace",
          button: "Learn More",
          imageGroup: [birthplaceofsenapatibapat1],
        },
        {
          id: "siddheshwar-mahadev-temple",
          title: "Siddheshwar Temple",
          button: "Learn More",
          imageGroup: [siddheshwarmahadevtemple1],
        },
      ],
    },
    मराठी: {
      title: "अहिल्यानगर जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नाशिक विभाग",
      divisionTitle: "अहिल्यानगर जिल्हा",
      cards: [
        {
          id: "birthplace-of-ahilyabai-holkar",
          title: "गढी - अहिल्याबाई होळकर जन्मस्थान (आणि संघ)",
          button: "अधिक जाणून घ्या",
          imageGroup: [ahilyabaitemple],
        },
        {
          id: "birthplace-of-ahilyabai-holkar-mahadev-temple",
          title: "गढी - अहिल्याबाई होळकर जन्मस्थान (आणि संघ) अ) महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahadevtemple],
        },
        {
          id: "birthplace-of-ahilyabai-holkar-chondeshwari-temple",
          title: "गढी - अहिल्याबाई होळकर जन्मस्थान (आणि संघ) ब) चोंडेश्वरी मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [chondeshwaritemple],
        },
        {
          id: "birthplace-of-ahilyabai-holkar-ahilyabai-temple",
          title: "गढी - अहिल्याबाई होळकर जन्मस्थान (आणि संघ) क) अहिल्याबाई मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [ahilyabaitemple],
        },
        {
          id: "harinarayan-math",
          title: "हरीनारायण मठ",
          button: "अधिक जाणून घ्या",
          imageGroup: [harinarayanamath1],
        },
        {
          id: "kharda-fort",
          title: "खर्डा किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [khardafort1],
        },
        {
          id: "lakshmi-temple",
          title: "लक्ष्मी मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [lakshmitemple1],
        },
        {
          id: "nimbalkar-gadi",
          title: "निंबाळकर गडी, निंबाळकर छत्री, ओंकारेश्वर मंदिर आणि बारव",
          button: "अधिक जाणून घ्या",
          imageGroup: [nimbalkargadhi1],
        },
        {
          id: "raghaveshwar-mahadev-temple",
          title: "राघवेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [raghaveshwarmahadevtemple11],
        },
        {
          id: "raghobadada-wada",
          title: "राघोबादादा वाडा",
          button: "अधिक जाणून घ्या",
          imageGroup: [raghobadadawada1],
        },
        {
          id: "senapati-bapat",
          title: "सेनापती बापट जन्मस्थान",
          button: "अधिक जाणून घ्या",
          imageGroup: [birthplaceofsenapatibapat1],
        },
        {
          id: "siddheshwar-mahadev-temple",
          title: "सिद्धेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [siddheshwarmahadevtemple1],
        },
      ]
    }
  },

  sambhajinagar: {
    English: {
      title: "Chhatrapati-Sambhajinagar District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "CHHATRAPATI-SAMBHAJINAGAR DIVISION",
      divisionTitle: "CHHATRAPATI-SAMBHAJINAGAR DISTRICT",
      cards: [
        {
          id: "abul-hasan-tan-shah",
          title: "Abul Hasan Tanashah Tomb",
          button: "Learn More",
          imageGroup: [abulhasan],
        },
        {
          id: "ajanta-sarai",
          title: "Ajanta Sarai",
          button: "Learn More",
          imageGroup: [ajantasarai1],
        },
        {
          id: "antur-fort",
          title: "Antur Fort",
          button: "Learn More",
          imageGroup: [anturfort1],
        },
        {
          id: "archaeological-site",
          title: "Archaeological Site (Yadav period)",
          button: "Learn More",
          imageGroup: [archlogiessite],
        },
        {
          id: "asaf-jahan-tomb",
          title: "Asafjaha Tomb",
          button: "Learn More",
          imageGroup: [aasafjahan],
        },
        {
          id: "tomb of-azam-shah",
          title: "Azamshah Tomb",
          button: "Learn More",
          imageGroup: [tombofazamshah1],
        },
        {
          id: "bani-begum-bagh",
          title: "Bani Begum Baug",
          button: "Learn More",
          imageGroup: [banibegumbagh1],
        },
        {
          id: "bhadkal-door",
          title: "Bhadkal Darwaza",
          button: "Learn More",
          imageGroup: [bhadkaldoor],
        },
        {
          id: "chowk-mosque",
          title: "Chauk Masjid",
          button: "Learn More",
          imageGroup: [chowk1],
        },
        {
          id: "delhi-gate",
          title: "Dilli Darwaza",
          button: "Learn More",
          imageGroup: [delhidarwaja],
        },
        {
          id: "ghatotkach-caves",
          title: "Ghatotkach Caves",
          button: "Learn More",
          imageGroup: [ghatotkach1],
        },
        {
          id: "jame-masjid-asafjahan",
          title: "Jame Masjid - Asafjahan",
          button: "Learn More",
          imageGroup: [jamemasjid1],
        },
        {
          id: "jogeshwari-devi-caves",
          title: "Jogeshwari Devi Caves",
          button: "Learn More",
          imageGroup: [jogeshwari1],
        },
        {
          id: "kali-masjid",
          title: "Kali Masjid",
          button: "Learn More",
          imageGroup: [kalimasjid],
        },
        {
          id: "khan-e-jahan-bagh",
          title: "Khan-e-Jahan Baug",
          button: "Learn More",
          imageGroup: [khanjahan],
        },
        {
          id: "khandoba-temple-sambhajinagar ",
          title: "Khandoba Temple",
          button: "Learn More",
          imageGroup: [khandobatemplesambhajinagar],
        },
        {
          id: "red-mosque",
          title: "Lal Masjid",
          button: "Learn More",
          imageGroup: [lalmasjid],
        },
        {
          id: "lala-hardaul-samadhi",
          title: "Lala Hardol Samadhi",
          button: "Learn More",
          imageGroup: [lalahardaaul],
        },
        {
          id: "makai-door",
          title: "Makai Darwaza",
          button: "Learn More",
          imageGroup: [makaidarwaja],
        },
        {
          id: "maloji-raje-bhosale's-fort",
          title: "Maloji Raje Bhosale Gadhi Remains",
          button: "Learn More",
          imageGroup: [malojirajefort],
        },
        {
          id: "munim-bagh",
          title: "Munim Baug",
          button: "Learn More",
          imageGroup: [munim],
        },
        {
          id: "nageshwar-temple-sambhajinager",
          title: "Nageshwar Temple",
          button: "Learn More",
          imageGroup: [nageshwar1],
        },
        {
          id: "narasimha-image",
          title: "Narasimha Sculpture",
          button: "Learn More",
          imageGroup: [narsihnha],
        },
        {
          id: "nasir-jung-tomb",
          title: "Nasirjung Tomb",
          button: "Learn More",
          imageGroup: [nasir1],
        },
        {
          id: "navkhanda-palace",
          title: "Navkhanda Palace",
          button: "Learn More",
          imageGroup: [navkhanda1],
        },
        {
          id: "watermill",
          title: "Panchakki",
          button: "Learn More",
          imageGroup: [panchakki],
        },
        {
          id: "inscribed-pillar",
          title: "Pillar with Inscription",
          button: "Learn More",
          imageGroup: [incriptedpillar],
        },
        {
          id: "prehistoric-neolithic-site",
          title: "Prehistoric Neolithic site",
          button: "Learn More",
          imageGroup: [prehistoric1],
        },
        {
          id: "rudreshwar-caves",
          title: "Rudreshwar",
          button: "Learn More",
          imageGroup: [rudreshwarecaves],
        },
        {
          id: "salarjung-baradari",
          title: "Salarjung Baradari",
          button: "Learn More",
          imageGroup: [salarjungbaradari1],
        },
        {
          id: "fardapur-sarai",
          title: "Sarai",
          button: "Learn More",
          imageGroup: [fardapursarai1],
        },
        {
          id: "shahganj-masjid",
          title: "Shahajang Masjid",
          button: "Learn More",
          imageGroup: [shahagujMasjid1],
        },
        {
          id: "royal-hammam",
          title: "Shahi Hamam",
          button: "Learn More",
          imageGroup: [royalhammam1],
        },
        {
          id: "seshashayi-vishnu",
          title: "Sheshashayi Vishnu",
          button: "Learn More",
          imageGroup: [sheshshahi],
        },
        {
          id: "golden-palace",
          title: "Soneri Mahal",
          button: "Learn More",
          imageGroup: [goldenpalace1],
        },
        {
          id: "taltam-fort",
          title: "Taltam Fort",
          button: "Learn More",
          imageGroup: [taltam1],
        },
        {
          id: "pilgrimage",
          title: "Tirthstambh",
          button: "Learn More",
          imageGroup: [pilgrimage1],
        },
        {
          id: "vadeshwar-mahadev-temple",
          title: "Wadeshwar Mahadeo Temple",
          button: "Learn More",
          imageGroup: [vadeshwartemple],
        },
        // {
        //   id: "sarai",
        //   title: "Sarai",
        //   button: "Learn More",
        //   imageGroup: [ajantasarai1],
        // },
        {
          id: "vetalwadi-fort",
          title: "Vetalwadi Fort",
          button: "Learn More",
          imageGroup: [vetalvadi],
        },
        // {
        //   id: "burhan-nizam-shaha-che-thadage",
        //   title: "Burhan Nizam Shaha che Thadage",
        //   button: "Learn More",
        //   imageGroup: [burhannizamshahachethadage1],
        // },
      ],
    },
    मराठी: {
      title: "छत्रपती संभाजीनगर जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "छत्रपती संभाजीनगर विभाग",
      divisionTitle: "छत्रपती संभाजीनगर जिल्हा",
      cards: [
        {
          id: "abul-hasan-tan-shah",
          title: "अबुल हसन तानाशाह थडगे",
          button: "अधिक जाणून घ्या",
          imageGroup: [abulhasan],
        },
        {
          id: "ajanta-sarai",
          title: "अजिंठा सराय ",
          button: "अधिक जाणून घ्या",
          imageGroup: [ajantasarai1],
        },
        {
          id: "antur-fort",
          title: "अंतुर किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [anturfort1],
        },
        {
          id: "archaeological-site",
          title: "पुरातत्वीय स्थळ (यादवकाळ)",
          button: "अधिक जाणून घ्या",
          imageGroup: [archlogiessite],
        },
        {
          id: "asaf-jahan-tomb",
          title: "असफजहां थडगे",
          button: "अधिक जाणून घ्या",
          imageGroup: [aasafjahan],
        },
        {
          id: "tomb of-azam-shah",
          title: "आझमशाह थडगे ",
          button: "अधिक जाणून घ्या",
          imageGroup: [tombofazamshah1],
        },
        {
          id: "bani-begum-bagh",
          title: "बनी बेगम बाग",
          button: "अधिक जाणून घ्या",
          imageGroup: [banibegumbagh1],
        },
        {
          id: "bhadkal-door",
          title: "भडकल दरवाजा",
          button: "अधिक जाणून घ्या",
          imageGroup: [bhadkaldoor],
        },
        {
          id: "chowk-mosque",
          title: "चौक मस्जिद",
          button: "अधिक जाणून घ्या",
          imageGroup: [chowk1],
        },
        {
          id: "delhi-gate",
          title: "दिल्ली दरवाजा",
          button: "अधिक जाणून घ्या",
          imageGroup: [delhidarwaja],
        },
        {
          id: "ghatotkach-caves",
          title: "घटोत्कच लेणी",
          button: "अधिक जाणून घ्या",
          imageGroup: [ghatotkach1],
        },
        {
          id: "jame-masjid-asafjahan",
          title: "जामे मस्जिद - असफजहाँ",
          button: "अधिक जाणून घ्या",
          imageGroup: [jamemasjid1],
        },
        {
          id: "jogeshwari-devi-caves",
          title: "जोगेश्वरी देवी लेणी",
          button: "अधिक जाणून घ्या",
          imageGroup: [jogeshwari1],
        },
        {
          id: "kali-masjid",
          title: "काली मस्जिद",
          button: "अधिक जाणून घ्या",
          imageGroup: [kalimasjid],
        },
        {
          id: "khan-e-jahan-bagh",
          title: "खान-ए-जहां बाग",
          button: "अधिक जाणून घ्या",
          imageGroup: [khanjahan],
        },
        {
          id: "khandoba-temple-sambhajinagar ",
          title: "खंडोबा मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [khandobatemplesambhajinagar],
        },
        {
          id: "red-mosque",
          title: "लाल मस्जिद",
          button: "अधिक जाणून घ्या",
          imageGroup: [lalmasjid],
        },
        {
          id: "lala-hardaul-samadhi",
          title: "लाला हरदौल समाधी",
          button: "अधिक जाणून घ्या",
          imageGroup: [lalahardaaul],
        },
        {
          id: "makai-door",
          title: "मकाई दरवाजा",
          button: "अधिक जाणून घ्या",
          imageGroup: [makaidarwaja],
        },
        {
          id: "maloji-raje-bhosale's-fort",
          title: "मालोजी राजे भोसलेंची गडी- अवशेष",
          button: "अधिक जाणून घ्या",
          imageGroup: [malojirajefort],
        },
        {
          id: "munim-bagh",
          title: "मुनीम बाग",
          button: "अधिक जाणून घ्या",
          imageGroup: [munim],
        },
        {
          id: "nageshwar-temple-sambhajinager",
          title: "नागेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [nageshwar1],
        },
        {
          id: "narasimha-image",
          title: "नरसिंह प्रतिमा",
          button: "अधिक जाणून घ्या",
          imageGroup: [narsihnha],
        },
        {
          id: "nasir-jung-tomb",
          title: "नासिरजंग थडगे",
          button: "अधिक जाणून घ्या",
          imageGroup: [nasir1],
        },
        {
          id: "navkhanda-palace",
          title: "नवखंडा महाल",
          button: "अधिक जाणून घ्या",
          imageGroup: [navkhanda1],
        },
        {
          id: "watermill",
          title: "पाणचक्की",
          button: "अधिक जाणून घ्या",
          imageGroup: [panchakki],
        },
        {
          id: "inscribed-pillar",
          title: "शिलालेख असलेला खांब",
          button: "अधिक जाणून घ्या",
          imageGroup: [incriptedpillar],
        },
        {
          id: "prehistoric-neolithic-site",
          title: "प्रागैतिहासिक नवाश्ययुगीन स्थळ",
          button: "अधिक जाणून घ्या",
          imageGroup: [prehistoric1],
        },
        {
          id: "rudreshwar-caves",
          title: "रुद्रेश्वर",
          button: "अधिक जाणून घ्या",
          imageGroup: [rudreshwarecaves],
        },
        {
          id: "salarjung-baradari",
          title: "सालारजंग बारादरी",
          button: "अधिक जाणून घ्या",
          imageGroup: [salarjungbaradari1],
        },
        {
          id: "fardapur-sarai",
          title: "सराय",
          button: "अधिक जाणून घ्या",
          imageGroup: [fardapursarai1],
        },
        {
          id: "shahganj-masjid",
          title: "शाहगंज मस्जिद",
          button: "अधिक जाणून घ्या",
          imageGroup: [shahagujMasjid1],
        },
        {
          id: "royal-hammam",
          title: "शाही हमाम",
          button: "अधिक जाणून घ्या",
          imageGroup: [royalhammam1],
        },
        {
          id: "seshashayi-vishnu",
          title: "शेषशायी विष्णू",
          button: "अधिक जाणून घ्या",
          imageGroup: [sheshshahi],
        },
        {
          id: "golden-palace",
          title: "सोनेरी महाल",
          button: "अधिक जाणून घ्या",
          imageGroup: [goldenpalace1],
        },
        {
          id: "taltam-fort",
          title: "तालतम किल्ला ",
          button: "अधिक जाणून घ्या",
          imageGroup: [taltam1],
        },
        {
          id: "pilgrimage",
          title: "तीर्थस्तंभ",
          button: "अधिक जाणून घ्या",
          imageGroup: [pilgrimage1],
        },
        {
          id: "vadeshwar-mahadev-temple",
          title: "वडेश्वर महादेव मंदिर ",
          button: "अधिक जाणून घ्या",
          imageGroup: [vadeshwartemple],
        },
        // {
        //   id: "inn",
        //   title: "सराय",
        //   button: "अधिक जाणून घ्या",
        //   imageGroup: [ajantasarai1],
        // },
        {
          id: "vetalwadi-fort",
          title: "वेताळवाडी किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [vetalvadi],
        },
        // {
        //   id: "burhan-nizam-shaha-che-thadage",
        //   title: "बुरहान निजाम शहाचे थडगे",
        //   button: "अधिक जाणून घ्या",
        //   imageGroup: [burhannizamshahachethadage1],
        // },
      ]
    }
  },


  jalna: {
    English: {
      title: "Jalna District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "CHHATRAPATI-SAMBHAJINAGAR DIVISION",
      divisionTitle: "JALNA DISTRICT",
      cards: [
        {
          id: "amargad",
          title: "Amargad",
          button: "Learn More",
          imageGroup: [amargad],
        },
        {
          id: "bhokardan-cave",
          title: "Bhokardan Caves",
          button: "Learn More",
          imageGroup: [Bhokardan],
        },
        {
          id: "jambuwant-temple",
          title: "Jambuvanta Temple",
          button: "Learn More",
          imageGroup: [jambuwanttemple],
        },
        {
          id: "mahadev-temple-anwa",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [mahadevtempleanwa],
        },
        {
          id: "prehistoric-site-jalna",
          title: "Prehistoric Site",
          button: "Learn More",
          imageGroup: [prehistoric],
        },
      ],
    },
    मराठी: {
      title: "जालना जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "छत्रपती संभाजीनगर विभाग",
      divisionTitle: "जालना जिल्हा",
      cards: [
        {
          id: "amargad",
          title: "अमरगड",
          button: "अधिक जाणून घ्या",
          imageGroup: [amargad],
        },
        {
          id: "bhokardan-cave",
          title: "भोकरदन लेणी",
          button: "अधिक जाणून घ्या",
          imageGroup: [Bhokardan],
        },
        {
          id: "jambuwant-temple",
          title: "जांबुवंत मंदिर ",
          button: "अधिक जाणून घ्या",
          imageGroup: [jambuwanttemple],
        },
        {
          id: "mahadev-temple-anwa",
          title: "महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahadevtempleanwa],
        },
        {
          id: "prehistoric-site-jalna",
          title: "प्रागैतिहासिक स्थळ",
          button: "अधिक जाणून घ्या",
          imageGroup: [prehistoric],
        },
      ]
    }
  },

  // Beed District Data

  beed: {
    English: {
      title: "Beed District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "CHHATRAPATI SAMBHAJINAGAR DIVISION",
      divisionTitle: "BEED DISTRICT",
      cards: [
        {
          id: "the-first-poet-shri-mukundraj",
          title: "Aadya Kavi Shri Mukundraj Samadhi",
          button: "Learn More",
          imageGroup: [mukundraj1],
        },
        {
          id: "amaleshwar-temple",
          title: "Amaleshwar Temple",
          button: "Learn More",
          imageGroup: [amaleshwar1],
        },
        {
          id: "dharmapuri-fort",
          title: "Dharmapuri Fort",
          button: "Learn More",
          imageGroup: [dharmapurifort1],
        },
        {
          id: "dharur-fort",
          title: "Dharur Fort",
          button: "Learn More",
          imageGroup: [dharurfort1],
        },
        {
          id: "stone-door",
          title: "Dhonda Darwaza",
          button: "Learn More",
          imageGroup: [stonedoor1],
        },

        {
          id: "rusty-door",
          title: "Gunj Darwaza",
          button: "Learn More",
          imageGroup: [rustydoor],
        },
        {
          id: "jam-e-masjid",
          title: "Jame-e-Masjid ",
          button: "Learn More",
          imageGroup: [jambuwanttemple],
        },

        {
          id: "jogai-assembly-hall",
          title: "Jogi Sabhamandap",
          button: "Learn More",
          imageGroup: [jogaihall],
        },
        {
          id: "kankaleshwar-temple",
          title: "Kankaleshwar Temple",
          button: "Learn More",
          imageGroup: [kankaleshwar1],
        },
        {
          id: "kedareshwar-temple-1",
          title: "Kedareshwar Temple",
          button: "Learn More",
          imageGroup: [kedareshwar1],
        },
        {
          id: "khandeshwari-temple",
          title: "Khandeshwari Temple",
          button: "Learn More",
          imageGroup: [khandeshwaritemple],
        },
        {
          id: "kholeshwar-temple",
          title: "Kholeshwar Temple",
          button: "Learn More",
          imageGroup: [kholeshwartemple],
        },
        {
          id: "angled-door",
          title: "Kotwali Darwaza",
          button: "Learn More",
          imageGroup: [angled1],
        },
        {
          id: "mahadev-temple-beed",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [mahadevtemplepatoda1],
        },
        {
          id: "tomb-of-the-tooth-of-muhammad-bin-tughlaq",
          title: "Muhammad Bin Tughlaq's Tomb (Teeth Remains)",
          button: "Learn More",
          imageGroup: [tombToothMuhammadbinTughlaq1],
        },
        {
          id: "pir-balshah-dargah",
          title: "Pir Balshah Dargah",
          button: "Learn More",
          imageGroup: [pirbalshahdargah1],
        },
        {
          id: "rajuri-gate",
          title: "Rajuri Darwaza",
          button: "Learn More",
          imageGroup: [rajurigate],
        },
        {
          id: "battle-pillar",
          title: "Ran Khamb",
          button: "Learn More",
          imageGroup: [battlepillar],
        },
        {
          id: "tomb-of-queen-annapurna-bai",
          title: "Rani Annapurnabai Samadhi",
          button: "Learn More",
          imageGroup: [tombannapurna],
        },
        {
          id: "shahenhavali-dargah",
          title: "Shehanshawali Dargah",
          button: "Learn More",
          imageGroup: [Shanshahawali],
        },
        {
          id: "rajuri-mosque",
          title: "Rajuri Mosque",
          button: "Learn More",
          imageGroup: [rajurimosque],
        },
      ]
    },
    मराठी: {
      title: "बीड जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "छत्रपती संभाजीनगर विभाग",
      divisionTitle: "बीड जिल्हा",
      cards: [
        {
          id: "the-first-poet-shri-mukundraj",
          title: "आद्य कवी श्री. मुकुंदराज यांची समाधी",
          button: "अधिक जाणून घ्या",
          imageGroup: [mukundraj1],
        },
        {
          id: "amaleshwar-temple",
          title: "अमलेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [amaleshwar1],
        },
        {
          id: "dharmapuri-fort",
          title: "धर्मपुरी किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [dharmapurifort1],
        },
        {
          id: "dharur-fort",
          title: "धारूर किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [dharurfort1],
        },
        {
          id: "stone-door",
          title: "धोंडा दरवाजा",
          button: "अधिक जाणून घ्या",
          imageGroup: [stonedoor1],
        },

        {
          id: "rusty-door",
          title: "गुंज दरवाजा",
          button: "अधिक जाणून घ्या",
          imageGroup: [rustydoor],
        },
        {
          id: "jam-e-masjid",
          title: "जाम ए मस्जिद",
          button: "अधिक जाणून घ्या",
          imageGroup: [amargad],
        },
        {
          id: "jogai-assembly-hall",
          title: "जोगाई सभामंडप",
          button: "अधिक जाणून घ्या",
          imageGroup: [jogaihall],
        },
        {
          id: "kankaleshwar-temple",
          title: "कंकालेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [kankaleshwar1],
        },
        {
          id: "kedareshwar-temple-1",
          title: "केदारेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [kedareshwar1],
        },
        {
          id: "khandeshwari-temple",
          title: "खांदेश्वरी मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [khandeshwaritemple],
        },
        {
          id: "kholeshwar-temple",
          title: "खोलेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [kholeshwartemple],
        },
        {
          id: "angled-door",
          title: "कोतवाली दरवाजा",
          button: "अधिक जाणून घ्या",
          imageGroup: [angled1],
        },
        {
          id: "pir-balshah-dargah",
          title: "पीर बालाशहा दर्गा",
          button: "अधिक जाणून घ्या",
          imageGroup: [pirbalshahdargah1],
        },
        {
          id: "mahadev-temple-beed",
          title: "महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahadevtemplepatoda1],
        },
        {
          id: "tomb-of-the-tooth-of-muhammad-bin-tughlaq",
          title: "मोहमद बिन तुघलकाचे कबर (दाताचे अवशेष)",
          button: "अधिक जाणून घ्या",
          imageGroup: [tombToothMuhammadbinTughlaq1],
        },
        {
          id: "rajuri-gate",
          title: "राजुरी दरवाजा",
          button: "अधिक जाणून घ्या",
          imageGroup: [rajurigate],
        },
        {
          id: "battle-pillar",
          title: "रण खांब",
          button: "अधिक जाणून घ्या",
          imageGroup: [battlepillar],
        },
        {
          id: "tomb-of-queen-annapurna-bai",
          title: "राणी अन्नपूर्णाबाई समाधी",
          button: "अधिक जाणून घ्या",
          imageGroup: [tombannapurna],
        },
        {
          id: "shahenhavali-dargah",
          title: "शहेनशहा वली दर्गा",
          button: "अधिक जाणून घ्या",
          imageGroup: [Shanshahawali],
        },
        {
          id: "rajuri-mosque",
          title: "राजुरी मशीद",
          button: "अधिक जाणून घ्या",
          imageGroup: [rajurimosque],
        },
      ]
    }
  },

  dharashiv: {
    English: {
      title: "Dharashiv District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "CHHATRAPATI-SAMBHAJINAGAR DIVISION",
      divisionTitle: "DHARASHIV DISTRICT",
      cards: [

        {
          id: "historical-place-dharashiv",
          title: "Archaeological Site - Govind Lakshman Chari",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "chambhar-caves",
          title: "Chambhar Caves",
          button: "Learn More",
          imageGroup: [chambharcaves1],
        },
        {
          id: "dharashiv-caves",
          title: "Dharashiv Caves",
          button: "Learn More",
          imageGroup: [dharashiv1],
        },
        {
          id: "ghummaja",
          title: "Ghummaz",
          button: "Learn More",
          imageGroup: [ghummja1],
        },

        {
          id: "hazrat-shamsuddin-dargah",
          title: "Hazrat Shamsuddin Dargah",
          button: "Learn More",
          imageGroup: [hazaratdargah],
        },

        {
          id: "hindu-temple-and-inscription",
          title: "Hindu Temple and Inscription",
          button: "Learn More",
          imageGroup: [hindumandir],
        },
        {
          id: "historical-place-kisan-mhaske",
          title: "Historical Site - (Kisan Mhaske) S. No.",
          button: "Learn More",
          imageGroup: [historicalplacekisanmhaske1],
        },
        {
          id: "historical-site-bairag-pandha",
          title: "Historical Site - Bairag Pandhar",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "historical-site-godavari-hill",
          title: "Historical Site - Godavari Tekdi",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "historical-site-kot-hill",
          title: "Historical Site - Kot Tekdi",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "historical-site-mahar-hill",
          title: "Historical Site - Mahar Tekdi",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "historical-site-mulani-hill",
          title: "Historical Site - Mulani Tekdi",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "historical-site-renuka-hill",
          title: "Historical Site - Renuka Tekdi",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "historical-site-suleiman-hill",
          title: "Histrorical Site - Suleman Tekdi",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "lavani-ghummaj",
          title: "Lavni Ghummaz",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-temple-umarga",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [mahadev11],
        },
        {
          id: "mahadev-temple-mankeshwar",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [mahadev111],
        },
        {
          id: "mahalakshmi-temple-jagji",
          title: "Mahalakshmi Temple",
          button: "Learn More",
          imageGroup: [mahalakshmitemple],
        },
        {
          id: "naldurg-fort",
          title: "Naldurg Fort",
          button: "Learn More",
          imageGroup: [naldurg1],
        },
        {
          id: "paranda-fort",
          title: "Paranda Fort",
          button: "Learn More",
          imageGroup: [paranda1],
        },
        {
          id: "prehistoric-stone-circle",
          title: "Prehistoric Stone Circle",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "saint-gorobaka's-house",
          title: "Sant Gorobaka Kaka Math",
          button: "Learn More",
          imageGroup: [gorobakahouse],
        },
        {
          id: "shivaguru-samadhi-temple",
          title: "Shivaguru Samadhi Temple",
          button: "Learn More",
          imageGroup: [shivgurutemple],
        },
        {
          id: "shrine",
          title: "Tirthknd",
          button: "Learn More",
          imageGroup: [shrine1],
        },
        {
          id: "trivikram-temple",
          title: "Trivikram Temple",
          button: "Learn More",
          imageGroup: [trivikramtemple1],
        },
        {
          id: "tulja-bhavani-temple",
          title: "Tulja Bhawani Temple",
          button: "Learn More",
          imageGroup: [tulja1],
        },
        {
          id: "uttareshwar",
          title: "Uttareshwar Temple",
          button: "Learn More",
          imageGroup: [uttareshwar1],
        },
      ],
    },
    मराठी: {
      title: "धाराशिव जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "छत्रपती संभाजीनगर विभाग",
      divisionTitle: "धाराशिव जिल्हा",
      cards: [

        {
          id: "historical-place-dharashiv",
          title: "पुरातत्त्वीय स्थळ मालक गोविंद लक्ष्मण चारी",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "chambhar-caves",
          title: "चांभार लेणी",
          button: "अधिक जाणून घ्या",
          imageGroup: [chambharcaves1],
        },
        {
          id: "dharashiv-caves",
          title: "धाराशिव लेणी",
          button: "अधिक जाणून घ्या",
          imageGroup: [dharashiv1],
        },
        {
          id: "ghummaja",
          title: "घुम्मज",
          button: "अधिक जाणून घ्या",
          imageGroup: [ghummja1],
        },
        {
          id: "hazrat-shamsuddin-dargah",
          title: "हजरत शमसुद्दीन दर्गा",
          button: "अधिक जाणून घ्या",
          imageGroup: [hazaratdargah],
        },
        {
          id: "hindu-temple-and-inscription",
          title: "हिंदू मंदिर आणि शिलालेख",
          button: "अधिक जाणून घ्या",
          imageGroup: [hindumandir],
        },
        {
          id: "historical-place-kisan-mhaske",
          title: "ऐतिहासिक स्थळ (स्तूप)- (किसन म्हस्के) एस. क्र.",
          button: "अधिक जाणून घ्या",
          imageGroup: [historicalplacekisanmhaske1],
        },
        {
          id: "historical-site-bairag-pandha",
          title: "ऐतिहासिक स्थळ - बैराग पांढर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "historical-site-godavari-hill",
          title: "ऐतिहासिक स्थळ गोदावरी टेकडी",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "historical-site-kot-hill",
          title: "ऐतिहासिक स्थळ - कोट टेकडी",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "historical-site-mahar-hill",
          title: "ऐतिहासिक स्थळ - महार टेकडी",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "historical-site-mulani-hill",
          title: "ऐतिहासिक स्थळ - मुलानी टेकडी",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "historical-site-renuka-hill",
          title: "ऐतिहासिक स्थळ - रेणूका टेकडी",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "historical-site-suleiman-hill",
          title: "ऐतिहासिक स्थळ - सुलेमान टेकडी",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "lavani-ghummaj",
          title: "लावणी घुम्मज",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-temple-umarga",
          title: "महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahadev11],
        },
        {
          id: "mahadev-temple-mankeshwar",
          title: "महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahadev111],
        },
        {
          id: "mahalakshmi-temple-jagji",
          title: "महालक्ष्मी मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahalakshmitemple],
        },
        {
          id: "naldurg-fort",
          title: "नळदुर्ग किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [taltam1],
        },
        {
          id: "paranda-fort",
          title: "परांडा किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [paranda1],
        },
        {
          id: "prehistoric-stone-circle",
          title: "प्रागैतीहासिक शिलावर्तुळ",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "saint-gorobaka's-house",
          title: "संत गोरोबा काकांच जन्मस्थान",
          button: "अधिक जाणून घ्या",
          imageGroup: [gorobakahouse],
        },
        {
          id: "shivaguru-samadhi-temple",
          title: "शिवगुरू समाधी मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [shivgurutemple],
        },
        {
          id: "shrine",
          title: "तीर्थकुंड",
          button: "अधिक जाणून घ्या",
          imageGroup: [shrine1],
        },
        {
          id: "trivikram-temple",
          title: "त्रिविक्रम मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [trivikramtemple1],
        },
        {
          id: "tulja-bhavani-temple",
          title: "तुळजा भवानी मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [tulja1],
        },
        {
          id: "uttareshwar",
          title: "उत्तरेश्व मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [uttareshwar1],
        },
      ],
    }
  },

  parbhani: {
    English: {
      title: "Parbhani District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NANDED DIVISION",
      divisionTitle: "PARBHANI DISTRICT",
      cards: [
        {
          id: "deepmala",
          title: "Deepmal",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "ganesha",
          title: "Ganpati Temple ",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "gokuleshwar-temple-and-barav",
          title: "Gokuleshwar Temple",
          button: "Learn More",
          imageGroup: [gokuleshwartemplebarav1],
        },
        {
          id: "gupteshwar",
          title: "Gupteshwar Temple",
          button: "Learn More",
          imageGroup: [gupteshwar1],
        },
        {
          id: "hanuman-temple",
          title: "Hanuman Temple ",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "hanuman-temple-charbatula",
          title: "Hanuman Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "hazrat-syed-shah-ghumat",
          title: "Hazrat Syed Shah Ghumaz",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "rituvihar-temple",
          title: "Hrutuvihar Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "jain-charthana",
          title: "Jain Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "jain-jintur",
          title: "Jain Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "jama-masjid",
          title: "Jama Masjid",
          button: "Learn More",
          imageGroup: [jamamasjid],
        },
        {
          id: "mahadev-temple-jod-temple",
          title: "Jod Mahadeo Temple",
          button: "Learn More",
          imageGroup: [mahadevtemplearadeshwar],
        },
        {
          id: "mother-of-the-hoof-temple",
          title: "Khurachi aai Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-temple-charthana",
          title: "Mahadeo Temple, Charthana",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-temple-aradeshwar",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [mahadevtemplearadeshwar],
        },
        {
          id: "nageshwar-parbhani",
          title: "Nageshwar",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "narasimha-temple-parbhani",
          title: "Narasinha Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "five-pandavas",
          title: "Panch Pandav Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "pathri-fort",
          title: "Pathri Fort",
          button: "Learn More",
          imageGroup: [pathrifort],
        },
        {
          id: "roshan-khans-tomb",
          title: "Roshankhan Tomb",
          button: "Learn More",
          imageGroup: [roshankhanstomb],
        },
        {
          id: "saint-janabais-tomb",
          title: "Saint Janabai Tomb",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "shah-mastans",
          title: "Shah Mastancha Dargah",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "shah-shamsuddin-dargah",
          title: "Shah Shamsuddin Dargah",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "siddheshwar-parbhani",
          title: "Siddheshwar Mahadeo Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "sutareshwar-temple",
          title: "Sutareshwar Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "ukandeshwar-temple",
          title: "Ukandeshwar Temple",
          button: "Learn More",
          imageGroup: [ukhandeshwartemple1],
        },
      ]
    },
    मराठी: {
      title: "परभणी जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नांदेड विभाग",
      divisionTitle: "परभणी जिल्हा",
      cards: [
        {
          id: "deepmala",
          title: "दीपमाळ",
          button: "अधिक जाणून घ्या",
          imageGroup: [tombToothMuhammadbinTughlaq1],
        },
        {
          id: "ganesha",
          title: "गणपती मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "gokuleshwar-temple-and-barav",
          title: "गोकुळेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [gokuleshwartemplebarav1],
        },
        {
          id: "gupteshwar",
          title: "गुप्तेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [gupteshwar1],
        },
        {
          id: "hanuman-temple",
          title: "हनुमान मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "hanuman-temple-charbatula",
          title: "हनुमान मंदिर, चारबातुला",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "hazrat-syed-shah-ghumat",
          title: "हजरत सय्यद शाह घुमट",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "rituvihar-temple",
          title: "ऋतूविहार मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "jain-charthana",
          title: "जैन चारठाणा",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "jain-jintur",
          title: "जैन जिंतूर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "jama-masjid",
          title: "जामा मस्जिद",
          button: "अधिक जाणून घ्या",
          imageGroup: [jamamasjid],
        },
        {
          id: "mahadev-temple-jod-temple",
          title: "महादेव मंदिर (जोड मंदिर)",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "mother-of-the-hoof-temple",
          title: "खुराची आई मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-temple-charthana",
          title: "महादेव मंदिर, चारठाणा",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-temple-aradeshwar",
          title: "महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahadevtemplearadeshwar],
        },
        {
          id: "nageshwar-parbhani",
          title: "नागेश्वर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "narasimha-temple-parbhani",
          title: "नरसिंह मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "five-pandavas",
          title: "पाच पांडव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "pathri-fort",
          title: "पाथरी किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [pathrifort],
        },
        {
          id: "roshan-khans-tomb",
          title: "रोशन खानची समाधी",
          button: "अधिक जाणून घ्या",
          imageGroup: [roshankhanstomb],
        },
        {
          id: "saint-janabais-tomb",
          title: "संत जनाबाई समाधी",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "shah-mastans",
          title: "शाह मस्तानचा दर्गा",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "shah-shamsuddin-dargah",
          title: "शाह शमसुद्दीन दर्गा",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "siddheshwar-parbhani",
          title: "सिध्देश्वर महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "sutareshwar-temple",
          title: "सुतारेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "ukandeshwar-temple",
          title: "उकंडेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [ukhandeshwartemple1],
        },
      ]
    }
  },
  // Hingoli District Data
  hingoli: {
    English: {
      title: "Hingoli District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NANDED DIVISION",
      divisionTitle: "HINGOLI DISTRICT",
      cards: [
        {
          id: "fallen-castle",
          title: "Fort Ruins",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "hemadpanti-temple",
          title: "Hemadpanti Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "hindu-temple",
          title: "Hindu Temple",
          button: "Learn More",
          imageGroup: [hindutemple],
        },
        {
          id: "jame-masjid-and-shah-tanklishah",
          title: "Jame Masjid and Shah Tanklishah",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "qazi-sahib-mosque",
          title: "Kazi Sahib Mosque",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "khan-e-alam-dargah",
          title: "Khan-e-Alam Dargah",
          button: "Learn More",
          imageGroup: [khanealamdargah],
        },
        {
          id: "mahadev-temple-101",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "nagnath-temple-aundha",
          title: "Nagnath Mahadeo Temple",
          button: "Learn More",
          imageGroup: [nagnathtempleaundha],
        },
        {
          id: "nrisimha-temple",
          title: "Narisimha Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "panch-pandava-temple",
          title: "Panch Pandav Temple (Jain)",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "birth-place-of saint-namdev",
          title: "Saint Namdev Birthplace",
          button: "Learn More",
          imageGroup: [birthplaceofsaintnamdev],
        },
        {
          id: "temple-and-twelve",
          title: "Temple and Step Well",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "vadgaon-fort",
          title: "Vadgaon Fort",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
      ]
    },
    मराठी: {
      title: "हिंगोली जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नांदेड विभाग",
      divisionTitle: "हिंगोली जिल्हा",
      cards: [
        {
          id: "fallen-castle",
          title: "पडलेला किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "hemadpanti-temple",
          title: "हेमाडपंती मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "hindu-temple",
          title: "हिंदू मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [hindutemple],
        },
        {
          id: "jame-masjid-and-shah-tanklishah",
          title: "जामे मस्जिद व शाह टंकळीशाह",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "qazi-sahib-mosque",
          title: "काझी साहेब मस्जिद",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "khan-e-alam-dargah",
          title: "खान-ए-आलम दर्गा",
          button: "अधिक जाणून घ्या",
          imageGroup: [khanealamdargah],
        },
        {
          id: "mahadev-temple-101",
          title: "महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "nagnath-temple-aundha",
          title: "नागनाथ मंदिर, औंढा",
          button: "अधिक जाणून घ्या",
          imageGroup: [nagnathtempleaundha],
        },
        {
          id: "nrisimha-temple",
          title: "नरसिंह महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "panch-pandava-temple",
          title: "पंच पांडव मंदिर (जैन),औंढा नागनाथ",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "birth-place-of saint-namdev",
          title: "संत नामदेव जन्मस्थान",
          button: "अधिक जाणून घ्या",
          imageGroup: [birthplaceofsaintnamdev],
        },
        {
          id: "temple-and-twelve",
          title: "मंदिर व बाराव",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "vadgaon-fort",
          title: "वडगाव किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
      ]
    }
  },

  // Latur District Data
  latur: {
    English: {
      title: "Latur District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NANDED DIVISION",
      divisionTitle: "LATUR DISTRICT",
      cards: [
        {
          id: "ausa-fort",
          title: "Ausa Fort",
          button: "Learn More",
          imageGroup: [ausafort],
        },
        {
          id: "bagh-e-hissam",
          title: "Baug-e-Hissam",
          button: "Learn More",
          imageGroup: [baghehissam],
        },
        {
          id: "goddess-temple",
          title: "Devi Mandir",
          button: "Learn More",
          imageGroup: [goddesstemple],
        },
        {
          id: "jame-masjid",
          title: "Jame Masjid",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "udgir-fort",
          title: "Udgir",
          button: "Learn More",
          imageGroup: [udgirfort],
        },
      ],
    },
    मराठी: {
      title: "लातूर जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नांदेड विभाग",
      divisionTitle: "लातूर जिल्हा",
      cards: [
        {
          id: "ausa-fort",
          title: "औसा किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [ausafort],
        },
        {
          id: "bagh-e-hissam",
          title: "बाग-ए-हिस्सम",
          button: "अधिक जाणून घ्या",
          imageGroup: [baghehissam],
        },
        {
          id: "goddess-temple",
          title: "देवी मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [goddesstemple],
        },
        {
          id: "jame-masjid",
          title: "जामे मस्जिद",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "udgir-fort",
          title: "उदगीर किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [udgirfort],
        },
      ]
    }
  },


  // Nanded District Data
  nanded: {
    English: {
      title: "Nanded District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NANDED DIVISION",
      divisionTitle: "NANDED DISTRICT",
      cards: [
        {
          id: "bhavani-temple-nanded",
          title: "Bhavani Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "bhog-narasimha-temple-ramalinga-temple",
          title: "Bhog Narasimha Temple and Ramling Temple",
          button: "Learn More",
          imageGroup: [bhognarsimhaandramlingtemple],
        },
        {
          id: "durbari-masjid-qutubshahi",
          title: "Darbari Masjid (Qutubshahi)",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },

        // {
        //   id: "dasharatheswar-temple-and-stepwell",
        //   title: "Dasharatheswar Temple and Stepwell",
        //   button: "Learn More",
        //   imageGroup: [rudreshwarecaves],
        // },

        {
          id: "gurdwara",
          title: "Gurdwara",
          button: "Learn More",
          imageGroup: [gurdwara],
        },
        {
          id: "elephant-farm",
          title: "Hatikhana",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "hazrat-sadruddin-and-badruddin",
          title: "Hazrat Sadaruddin and Badaruddin",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "hindu-caves",
          title: "Hindu Caves",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "idgah",
          title: "Idgah",
          button: "Learn More",
          imageGroup: [idgah],
        },
        {
          id: "jama-masjid-malik-ambar",
          title: "Jama Masjid (Malik Ambar)",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "kandahar-fort",
          title: "Kandhar Fort",
          button: "Learn More",
          imageGroup: [kandaharfort1],
        },
        {
          id: "kshetrapal-temple-ruins",
          title: "Kshetrapal Temple Remains",
          button: "Learn More",
          imageGroup: [kshtrapaltempleruin1],
        },
        {
          id: "mahadevtemple-nanded",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [mahadevtemplenanded2],
        },
        {
          id: "mahadev-temple-nanded",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [mahadevtemplenanded1],
        },
        {
          id: "mahadev-temple-khanapur",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-temple-hadgaon",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahur-fort-nanded",
          title: "Mahur Fort",
          button: "Learn More",
          imageGroup: [mahurfort1],
        },
        {
          id: "maturitirth-lake",
          title: "Maturitirth Talav",
          button: "Learn More",
          imageGroup: [maturitirthlake],
        },
        {
          id: "nandagiri-fort",
          title: "Nandagiri Fort",
          button: "Learn More",
          imageGroup: [nandagirifort1],
        },
        {
          id: "nandi-remains-temple",
          title: "Nandi and Temple Remains",
          button: "Learn More",
          imageGroup: [nanditemple],
        },
        {
          id: "nandi-temple-and-kund",
          title: "Nandi Temple and Tank",
          button: "Learn More",
          imageGroup: [nanditemplekund],
        },
        {
          id: "narasimha-temple-complex",
          title: "Narasimha Temple Complex",
          button: "Learn More",
          imageGroup: [narasimhatemplecomplex],
        },
        {
          id: "narasimha-temple-and-idol",
          title: "Narasimha Temple and Sculpture",
          button: "Learn More",
          imageGroup: [bhadkaldoor],
        },
        {
          id: "pandava",
          title: "Pandavleni",
          button: "Learn More",
          imageGroup: [pandavapas],
        },
        {
          id: "parameshwar-mandir-hottal",
          title: "Parameshwar Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "parameshwar-mandir",
          title: "Parameshwar Temple",
          button: "Learn More",
          imageGroup: [parameshwarmandir],
        },
        {
          id: "parvati-temple",
          title: "Parvati Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "renukadevi-temple",
          title: "Renukadevi Temple",
          button: "Learn More",
          imageGroup: [renukadevitemple],
        },
        {
          id: "sarfraz-khan-masjid",
          title: "Sarfraz Khan Masjid",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "shah-luthfullah-dargah",
          title: "Shah Luthfullah Dargah",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "sonapir-dargah",
          title: "Sonapir Dargah",
          button: "Learn More",
          imageGroup: [sonapirdargah],
        },
        {
          id: "anshwar-mahadev-temple",
          title: "Unkeshwar Mahadeo Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "yoganrisimha-temple",
          title: "Yognarisimha Temple",
          button: "Learn More",
          imageGroup: [yoganrisimhatemple],
        },
        {
          id: "zainuddin-rafai-dargah",
          title: "Zainuddin Rafai",
          button: "Learn More",
          imageGroup: [zainuddinrafaidargah1],
        },
      ],
    },
    मराठी: {
      title: "नांदेड जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नांदेड विभाग",
      divisionTitle: "नांदेड जिल्हा",
      cards: [
        {
          id: "bhavani-temple-nanded",
          title: "भवानी मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "bhog-narasimha-temple-ramalinga-temple",
          title: "भोग नृसिंह मंदिर व रामलिंग मंदिर ",
          button: "अधिक जाणून घ्या",
          imageGroup: [bhognarsimhaandramlingtemple],
        },
        {
          id: "durbari-masjid-qutubshahi",
          title: "दरबारी मस्जिद (कुतुबशाही)",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        //  {
        //   id: "dasharatheswar-temple-and-stepwell",
        //   title: "दाशरथेæवर मंǑदर व बारव",
        //   button: "अधिक जाणून घ्या",
        //   imageGroup: [rudreshwarecaves],
        // },
        {
          id: "gurdwara",
          title: "गुरुद्वारा",
          button: "अधिक जाणून घ्या",
          imageGroup: [gurdwara],
        },
        {
          id: "elephant-farm",
          title: "हातीखाना",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "hazrat-sadruddin-and-badruddin",
          title: "हजरत सदरुददीन व बदरुददीन",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "hindu-caves",
          title: "हिंदू लेणी",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "idgah",
          title: "इदगाह",
          button: "अधिक जाणून घ्या",
          imageGroup: [idgah],
        },
        {
          id: "jama-masjid-malik-ambar",
          title: "जामा मस्जिद (मालिक अंबर)",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "kandahar-fort",
          title: "कंधार किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [kandaharfort1],
        },
        {
          id: "kshetrapal-temple-ruins",
          title: "क्षेत्रपाल मंदिर अवशेष",
          button: "अधिक जाणून घ्या",
          imageGroup: [kshtrapaltempleruin1],
        },
        {
          id: "mahadevtemple-nanded",
          title: "महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahadevtemplenanded2],
        },
        {
          id: "mahadev-temple-nanded",
          title: "महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahadevtemplenanded1],
        },
        {
          id: "mahadev-temple-khanapur",
          title: "महादेव मंदिर खानापूर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-temple-hadgaon",
          title: "महादेव मंदिर हदगाव",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahur-fort-nanded",
          title: "माहूर किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahurfort1],
        },
        {
          id: "maturitirth-lake",
          title: "मातृतीर्थ तलाव",
          button: "अधिक जाणून घ्या",
          imageGroup: [maturitirthlake],
        },
        {
          id: "nandagiri-fort",
          title: "नंदगिरी किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [nandagirifort1],
        },
        {
          id: "nandi-remains-temple",
          title: "नंदी व मंदिराशेष",
          button: "अधिक जाणून घ्या",
          imageGroup: [nanditemple],
        },
        {
          id: "nandi-temple-and-kund",
          title: "नंदी मंदिर व कुंड",
          button: "अधिक जाणून घ्या",
          imageGroup: [nanditemplekund],
        },
        {
          id: "narasimha-temple-complex",
          title: "नृसिंह मंदिर संकुल",
          button: "अधिक जाणून घ्या",
          imageGroup: [narasimhatemplecomplex],
        },
        {
          id: "narasimha-temple-and-idol",
          title: "नृसिंह मंदिर आणि मूर्ती",
          button: "अधिक जाणून घ्या",
          imageGroup: [bhadkaldoor],
        },
        {
          id: "pandava",
          title: "पांडवलेणी",
          button: "अधिक जाणून घ्या",
          imageGroup: [pandavapas],
        },
        {
          id: "parameshwar-mandir-hottal",
          title: "परमेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "parameshwar-mandir",
          title: "परमेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [parameshwarmandir],
        },
        {
          id: "parvati-temple",
          title: "पार्वती मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "renukadevi-temple",
          title: "रेणुकादेवी मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [renukadevitemple],
        },
        {
          id: "sarfraz-khan-masjid",
          title: "सरफराज खान मस्जिद",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "shah-luthfullah-dargah",
          title: "शहा लुथफुल्लाह दर्गा",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "sonapir-dargah",
          title: "सोनापीर दर्गा",
          button: "अधिक जाणून घ्या",
          imageGroup: [sonapirdargah],
        },
        {
          id: "anshwar-mahadev-temple",
          title: "उनकेश्वर महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "yoganrisimha-temple",
          title: "योगनृसिंह मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [yoganrisimhatemple],
        },
        {
          id: "zainuddin-rafai-dargah",
          title: "झैनउद्यीन रफाई दर्गा",
          button: "अधिक जाणून घ्या",
          imageGroup: [zainuddinrafaidargah1],
        },

      ],
    }
  },

  akola: {
    English: {
      title: "Akola District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NAGPUR DIVISION",
      divisionTitle: "NAGPUR DISTRICT",
      cards: [
        {
          id: "badi-roja-masjid",
          title: "Badi Roza Masjid",
          button: "Learn More",
          imageGroup: [badiroja],
        },
        {
          id: "darush-shararra-of-kanchani",
          title: "Darur Sharar (Masjid)",
          button: "Learn More",
          imageGroup: [darush],
        },
        {
          id: "door",
          title: "Darwaza",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "inayat-manzil",
          title: "Inayat Manzil",
          button: "Learn More",
          imageGroup: [inayat],
        },
        {
          id: "jaddeala-dargah-and-mosque",
          title: "Jaddeaala Dargah and Masjid",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
      ]
    },
    मराठी: {
      title: "अकोला जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नागपूर विभाग",
      divisionTitle: "अकोला जिल्हा",
      cards: [
        {
          id: "badi-roja-masjid",
          title: "बडी रोजा मस्जिद",
          button: "अधिक जाणून घ्या",
          imageGroup: [badiroja],
        },
        {
          id: "darush-shararra-of-kanchani",
          title: "कंचनीचा दारुश शरर्रा",
          button: "अधिक जाणून घ्या",
          imageGroup: [darush],
        },
        {
          id: "door",
          title: "दरवाजा",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "inayat-manzil",
          title: "इनायत मंजिल",
          button: "अधिक जाणून घ्या",
          imageGroup: [inayat],
        },
        {
          id: "jaddeala-dargah-and-mosque",
          title: "जद्देआला दर्गा आणि मस्जिद",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
      ]
    }
  },


  // Buldhana District Data
  buldhana: {
    English: {
      title: "Buldhana District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NAGPUR DIVISION",
      divisionTitle: "BULDHANA DISTRICT",
      cards: [
        {
          id: "kanchani-palace",
          title: "Kanchanicha Mahal",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "lakhuji-jadhav-wada",
          title: "Lakhuji Jadhav Wada",
          button: "Learn More",
          imageGroup: [lakhuji],
        },
        {
          id: "pearl-lake",
          title: "Moti Talav",
          button: "Learn More",
          imageGroup: [moti],
        },
        {
          id: "nilkantheshwar-temple-and-barav",
          title: "Nilkantheshwar Temple and Stepwell",
          button: "Learn More",
          imageGroup: [nilkantheshwar],
        },
        {
          id: "rangmahal",
          title: "Rangmahal",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "maonylender",
          title: "Savakarwada",
          button: "Learn More",
          imageGroup: [Savakarwada],
        },
      ]
    },
    मराठी: {
      title: "बुलढाणा जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नागपूर विभाग",
      divisionTitle: "बुलढाणा जिल्हा",
      cards: [
        {
          id: "kanchani-palace",
          title: "कंचनीचा महाल",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "lakhuji-jadhav-wada",
          title: "लखुजी जाधव वाडा",
          button: "अधिक जाणून घ्या",
          imageGroup: [lakhuji],
        },
        {
          id: "pearl-lake",
          title: "मोती तलाव",
          button: "अधिक जाणून घ्या",
          imageGroup: [moti],
        },
        {
          id: "nilkantheshwar-temple-and-barav",
          title: "निळकंठेश्वर मंदिर आणि बारव",
          button: "अधिक जाणून घ्या",
          imageGroup: [nilkantheshwar],
        },
        {
          id: "rangmahal",
          title: "रंगमहाल",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "maonylender",
          title: "सावकारवाडा",
          button: "अधिक जाणून घ्या",
          imageGroup: [Savakarwada],
        },
      ]
    }
  },

  // washim District Data
  washim: {
    English: {
      title: "Washim District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NAGPUR DIVISION",
      divisionTitle: "WASHIM DISTRICT",
      cards: [
        {
          id: "doorway-ways",
          title: "Darwaha Darwaza (Ves) ",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "delhi-gate-wes",
          title: "Dilli Darwaza (Ves)",
          button: "Learn More",
          imageGroup: [Delhigate],
        },

        {
          id: "mangrul-door-wes",
          title: "Mangrul Darwaza",
          button: "Learn More",
          imageGroup: [Mangruldoor],
        },
        {
          id: "poha-door-wes",
          title: "Poha Darwaza (Ves)",
          button: "Learn More",
          imageGroup: [Pohadoor],
        },
      ]
    },
    मराठी: {
      title: "वाशिम जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नागपूर विभाग",
      divisionTitle: "वाशिम जिल्हा",
      cards: [
        {
          id: "doorway-ways",
          title: "दारव्हा दरवाजा (वेस)",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "delhi-gate-wes",
          title: "दिल्ली दरवाजा (वेस)",
          button: "अधिक जाणून घ्या",
          imageGroup: [Delhigate],
        },
        {
          id: "mangrul-door-wes",
          title: "मंगरुळ दरवाजा (वेस)",
          button: "अधिक जाणून घ्या",
          imageGroup: [Mangruldoor],
        },
        {
          id: "poha-door-wes",
          title: "पोहा दरवाजा (वेस)",
          button: "अधिक जाणून घ्या",
          imageGroup: [Pohadoor],
        },
      ]
    }
  },
  yavatmal: {
    English: {
      title: "Yavatmal District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NAGPUR DIVISION",
      divisionTitle: "YAVATMAL DISTRICT",
      cards: [
        {
          id: "kedareshwar-temple",
          title: "Kedareshwar Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-temple-yavatmal",
          title: "Mahadeo Temple ",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
      ]
    },
    मराठी: {
      title: "यवतमाळ जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नागपूर विभाग",
      divisionTitle: "यवतमाळ जिल्हा",
      cards: [
        {
          id: "kedareshwar-temple",
          title: "केदारेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-temple-yavatmal ",
          title: "महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
      ]
    }
  },
  // Amravati 
  amravati: {
    English: {
      title: "Amravati District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NAGPUR DIVISION",
      divisionTitle: "AMRAVATI DISTRICT",
      cards: [
        {
          id: "mango-door",
          title: "Amba Darwaza",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "jawahar-darwaza",
          title: "Jawahar Darwaza",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "stepwell",
          title: "Payryachi Vihir",
          button: "Learn More",
          imageGroup: [stepwell],
        },
        {
          id: "mother-in-law-well",
          title: "Sasu Sunechi Vihir",
          button: "Learn More",
          imageGroup: [mother],
        },
      ]
    },
    मराठी: {
      title: "अमरावती जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नागपूर विभाग",
      divisionTitle: "अमरावती जिल्हा",
      cards: [
        {
          id: "mango-door",
          title: "अंबा दरवाजा",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "jawahar-darwaza",
          title: "जवाहर दरवाजा",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "stepwell",
          title: "पायऱ्यांची विहीर",
          button: "अधिक जाणून घ्या",
          imageGroup: [stepwell],
        },
        {
          id: "mother-in-law-well",
          title: "सासू- सुनेची विहीर",
          button: "अधिक जाणून घ्या",
          imageGroup: [mother],
        },
      ]
    }
  },

  // bhandara District Data
  bhandara: {
    English: {
      title: "bhandara District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NAGPUR DIVISION",
      divisionTitle: "BHANDARA DISTRICT",
      cards: [
        {
          id: "ambagad-fort",
          title: "Ambagad",
          button: "Learn More",
          imageGroup: [ambagad],
        },
        {
          id: "gosavi-samadhi",
          title: "Gosavi Samadhi",
          button: "Learn More",
          imageGroup: [gosavi],
        },
        {
          id: "muralidhar-temple",
          title: "Muralidhar Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
      ]
    },
    मराठी: {
      title: "भंडारा जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नागपूर विभाग",
      divisionTitle: "भंडारा जिल्हा",
      cards: [
        {
          id: "ambagad-fort",
          title: "अंबागड",
          button: "अधिक जाणून घ्या",
          imageGroup: [ambagad],
        },
        {
          id: "gosavi-samadhi",
          title: "गोसावी समाधी",
          button: "अधिक जाणून घ्या",
          imageGroup: [gosavi],
        },
        {
          id: "muralidhar-temple",
          title: "मुरलीधर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
      ]
    }
  },

  //Chandrapur District
  chandrapur: {
    English: {
      title: "Chandrapur District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NAGPUR DIVISION",
      divisionTitle: "CHANDRAPUR DISTRICT",
      cards: [
        {
          id: "bhavani-temple",
          title: "Bhavani Temple",
          button: "Learn More",
          imageGroup: [bhavanitemplechandrapur],
        },
        {
          id: "garudasthamphan",
          title: "Garud Stambh",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-temple-babupeth",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-temple-bhatala",
          title: "Mahadeo Temple",
          button: "Learn More",
          imageGroup: [mahadevtemplebhatala],
        },
        {
          id: "manikgad-fort",
          title: "Manikgad",
          button: "Learn More",
          imageGroup: [manikgadfort],
        },
        {
          id: "prehistoric-site",
          title: "Prehistoric Site",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "rishi-lake-cave",
          title: "Rishi Talav (Cave)",
          button: "Learn More",
          imageGroup: [rishilakecave],
        },
        {
          id: "shankar-temple",
          title: "Shankar Temple",
          button: "Learn More",
          imageGroup: [shankartemple],
        },
        {
          id: "someshwar-temple",
          title: "Someshwar Temple",
          button: "Learn More",
          imageGroup: [someshwartemple],
        },
        {
          id: "vishnu-temple",
          title: "Vishnu Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },

      ]
    },
    मराठी: {
      title: "चंद्रपूर जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नागपूर विभाग",
      divisionTitle: "चंद्रपूर जिल्हा",
      cards: [
        {
          id: "bhavani-temple",
          title: "भवानी मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [bhavanitemplechandrapur],
        },
        {
          id: "garudasthamphan",
          title: "गरुडस्तंभ",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-temple-babupeth",
          title: "महादेव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-temple-bhatala",
          title: "महादेव मंदिर ",
          button: "अधिक जाणून घ्या",
          imageGroup: [mahadevtemplebhatala],
        },
        {
          id: "manikgad-fort",
          title: "माणिकगड किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [manikgadfort],
        },
        {
          id: "prehistoric-site",
          title: "प्रागैतिहासिक स्थळ",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "rishi-lake-cave",
          title: "ऋषी तलाव (लेणी)",
          button: "अधिक जाणून घ्या",
          imageGroup: [rishilakecave],
        },
        {
          id: "shankar-temple",
          title: "शंकर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [shankartemple],
        },
        {
          id: "someshwar-temple",
          title: "सोमेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [someshwartemple],
        },
        {
          id: "vishnu-temple",
          title: "विष्णु मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },

      ]
    }
  },
  // Nagpur District Data 
  nagpur: {
    English: {
      title: "Nagpur District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NAGPUR DIVISION",
      divisionTitle: "NAGPUR DISTRICT",
      cards: [
        {
          id: "bhogram-temple",
          title: "Bhogram Temple",
          button: "Learn More",
          imageGroup: [bhogramtemple],
        },
        {
          id: "bhola-hudki-archeological-site",
          title: "Bhola Hudki Archaeological Site",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "chandra-mouli-temple",
          title: "Chandramauli Temple - S. No. 2943",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "umbrella-no-19",
          title: "Chatri No. 19",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "umbrella-no-24",
          title: "Chatri No. 24",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "umbrella-no-26",
          title: "Chatri No. 26",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "umbrella-no-3",
          title: "Chatri No. 3",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "umbrella-no-4",
          title: "Chatri No. 4",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "datta-mandir-ambala-lake",
          title: "Datta Mandir, Ambala Lake",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "datta-temple",
          title: "Datta Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "hospice",
          title: "Dharmashala S. No. 2951 ",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "ganesh-temple",
          title: "Ganesh Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "harihara-samadhi-temple",
          title: "Harihar Samadhi Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "harihar-temple",
          title: "Harihar Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "jagannath-temple",
          title: "Jagannath Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "kapatram-temple-gupta-ram-temple",
          title: "Kapatram Temple (Gupta Ram Temple)",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "kapureshwar-temple",
          title: "Kapureshwar Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "keval-narsimha-temple",
          title: "Keval Narasimha Temple",
          button: "Learn More",
          imageGroup: [kevalnarasimbha],
        },
        {
          id: "laxman-swamy-temple",
          title: "Laxman Swami Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-mandir-no-32",
          title: "Mahadeo Mandir no. 32",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-mandir-no-06",
          title: "Mahadeo Mandir no. 06",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "nagardhan-fort",
          title: "Nagardhan Fort",
          button: "Learn More",
          imageGroup: [nagardhantemple],
        },
        {
          id: "panchshikhari-temple",
          title: "Panchshikhari Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "purushottam-maharaj-temple",
          title: "Purushottam Maharaj Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "ram-ganesh-gadkari-memorial",
          title: "Ram Ganesh Gadkari Memorial",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "ram-swamy-temple",
          title: "Ram Swami Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "ram-temple",
          title: "Ram Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "queen-saheb-bakhar",
          title: "Rani Saheb Samadhi S. No. 2955",
          button: "Learn More",
          imageGroup: [ranisahebsamadhi],
        },
        {
          id: "renuka-temple",
          title: "Renuka Temple",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "rudra-nrisimha-temple",
          title: "Rudra Nrisimha Temple",
          button: "Learn More",
          imageGroup: [rudranrisimbhatemple],
        },
        {
          id: "saraswati-temple-and-pond",
          title: "Saraswati Temple and Tank",
          button: "Learn More",
          imageGroup: [saraswatitemple],
        },
        {
          id: "shiva-temple",
          title: "Shiva Temple",
          button: "Learn More",
          imageGroup: [shivatemplenagpur],
        },
        {
          id: "shiva-temple-no-10",
          title: "Shiva Temple No. 10",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-11",
          title: "Shiva Temple No. 11",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-12",
          title: "Shiva Temple No. 12",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-17",
          title: "Shiva Temple No. 17",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-02",
          title: "Shiva Temple No. 02",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-27",
          title: "Shiva Temple No. 27",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-30",
          title: "Shiva Temple No. 30",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-31",
          title: "Shiva Temple No. 31",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-05",
          title: "Shiva Temple No. 05",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-07",
          title: "Shiva Temple No. 07",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-09",
          title: "Shiva Temple No. 09",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
        {
          id: "umred-fort",
          title: "Umred Fort",
          button: "Learn More",
          imageGroup: [umredfortnagpur],
        },
        {
          id: "varaha-temple-pavilion",
          title: "Varaha Temple",
          button: "Learn More",
          imageGroup: [varahatemple],
        },
        {
          id: "vitthal-temple",
          title: "Vitthal Temple (Mulmule)",
          button: "Learn More",
          imageGroup: [Dummyimg],
        },
      ]
    },
    मराठी: {
      title: "नागपूर जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नागपूर विभाग",
      divisionTitle: "नागपूर जिल्हा",
      cards: [
        {
          id: "bhogram-temple",
          title: "भोगराम मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [bhogramtemple],
        },
        {
          id: "bhola-hudki-archeological-site",
          title: "भोळा हुडकी पुरातत्वीय क्षेत्र",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "chandra-mouli-temple",
          title: "चंद्रामौली मंदिर-नभूमा क्र. 2953",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "umbrella-no-19",
          title: "छत्री क्र. १९",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "umbrella-no-24",
          title: "छत्री क्र. २४",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "umbrella-no-26",
          title: "छत्री क्र. २६",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "umbrella-no-3",
          title: "छत्री क्र. ३",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "umbrella-no-4",
          title: "छत्री क्र. ४",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "datta-mandir-ambala-lake",
          title: "दत्तमंदिर, अंबाळा तलाव",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "datta-temple",
          title: "दत्त मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "hospice",
          title: "धर्मशाळा नभूक्र 2951",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "ganesh-temple",
          title: "गणेश मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "harihara-samadhi-temple",
          title: "हरिहार समाधी मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "harihar-temple",
          title: "हरिहर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "jagannath-temple",
          title: "जगन्नाथ मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "kapatram-temple-gupta-ram-temple",
          title: "कपटराम मंदिर (गुप्त राम मंदिर)",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "kapureshwar-temple",
          title: "कपुरेश्वर मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "keval-narsimha-temple",
          title: "केवल नरसिंह मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [kevalnarasimbha],
        },
        {
          id: "laxman-swamy-temple",
          title: "लक्ष्मण स्वामी मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-mandir-no-32",
          title: "महादेव मंदिर क्र. ३२",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "mahadev-mandir-no-06",
          title: "महादेव मंदिर क्र. ०६",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "nagardhan-fort",
          title: "नगरधन किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [nagardhantemple],
        },
        {
          id: "panchshikhari-temple",
          title: "पंचशिखरी मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "purushottam-maharaj-temple",
          title: "पुरुषोत्तम महाराज मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "ram-ganesh-gadkari-memorial",
          title: "राम गणेश गडकरी स्मारक",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "ram-swamy-temple",
          title: "राम स्वामी मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "ram-temple",
          title: "राम मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "queen-saheb-bakhar",
          title: "राणी साहेबांची समाधी नभूक्र.2955 ",
          button: "अधिक जाणून घ्या",
          imageGroup: [ranisahebsamadhi],
        },
        {
          id: "renuka-temple",
          title: "रेणुका मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "rudra-nrisimha-temple",
          title: "रुद्र नृसिंहा मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [rudranrisimbhatemple],
        },
        {
          id: "saraswati-temple-and-pond",
          title: "सरस्वती मंदिर आणि कुंड",
          button: "अधिक जाणून घ्या",
          imageGroup: [saraswatitemple],
        },
        {
          id: "shiva-temple",
          title: "शिव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [shivatemplenagpur],
        },
        {
          id: "shiva-temple-no-10",
          title: "शिव मंदिर क्र. १०",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-11",
          title: "शिव मंदिर क्र. ११",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-12",
          title: "शिव मंदिर क्र. १२",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-17",
          title: "शिव मंदिर क्र. १७",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-02",
          title: "शिव मंदिर क्र. ०२",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-27",
          title: "शिव मंदिर क्र. २७",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-30",
          title: "शिव मंदिर क्र. ३०",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-31",
          title: "शिव मंदिर क्र. ३१",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-05",
          title: "शिव मंदिर क्र. ०५",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-07",
          title: "शिव मंदिर क्र. ०७",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "shiva-temple-no-09",
          title: "शिव मंदिर क्र. ०९",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
        {
          id: "umred-fort",
          title: "उमरेड किल्ला",
          button: "अधिक जाणून घ्या",
          imageGroup: [umredfortnagpur],
        },
        {
          id: "varaha-temple-pavilion",
          title: "वराह मंदिर मंडप",
          button: "अधिक जाणून घ्या",
          imageGroup: [varahatemple],
        },
        {
          id: "vitthal-temple",
          title: "विठ्ठल मंदिर (मुलमुले)",
          button: "अधिक जाणून घ्या",
          imageGroup: [Dummyimg],
        },
      ]
    }
  },
  //Gondia District
  gondia: {
    English: {
      title: "Gondia District",
      breadcrumb: "HOME",
      breadcrumbmuseum: "NAGPUR DIVISION",
      divisionTitle: "GONDIA DISTRICT",
      cards: [
        {
          id: "kalabhairava-temple",
          title: "Kalbhairav Temple",
          button: "Learn More",
          imageGroup: [kalabhairavatemplegondia],
        },
      ]
    },
    मराठी: {
      title: "गोंदिया जिल्हा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbmuseum: "नागपूर विभाग",
      divisionTitle: "गोंदिया जिल्हा",
      cards: [
        {
          id: "kalabhairava-temple",
          title: "कालभैरव मंदिर",
          button: "अधिक जाणून घ्या",
          imageGroup: [kalabhairavatemplegondia],
        },
      ]
    }
  },
};

export default districtData;
